var _defs, _g, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPiloto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Piloto",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 248,
    height: 248,
    viewBox: "0 0 248 248",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID",
    d: "M-2220.365,1982.923c19.64-8.524,25.936,5.072,38.391-.334s9.254-19.841,9.254-19.841-8.357-12.2-20.812-6.792S-2200.725,1974.4-2220.365,1982.923Z",
    transform: "translate(2220.365 -1954.574)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8141",
    "data-name": "Grupo 8141",
    transform: "translate(-557.277 -37.713)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6195",
    "data-name": "Grupo 6195"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_806",
    "data-name": "Trazado 806",
    d: "M594.715,229.873a10.055,10.055,0,0,0-.949,14.357,118.7,118.7,0,0,0,175.485,1.762,10.015,10.015,0,0,0-1.278-14.731l-85.447-65.812a10.033,10.033,0,0,0-12.632.314Z",
    fill: "#655dc6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_807",
    "data-name": "Trazado 807",
    d: "M669.961,166.764l-73.7,62.851c22.317,23.663,54.12,40.076,89.081,39.205,31.974-.8,60.671-16.231,81.5-37.485l-84.243-64.886A10.033,10.033,0,0,0,669.961,166.764Z",
    fill: "#524ba4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_209",
    "data-name": "Elipse 209",
    cx: 99.071,
    cy: 99.071,
    r: 99.071,
    transform: "translate(582.476 53.912)",
    fill: "#ffde00"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_210",
    "data-name": "Elipse 210",
    cx: 89.464,
    cy: 89.464,
    r: 89.464,
    transform: "translate(592.083 63.52)",
    fill: "#fc9a05"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6196",
    "data-name": "Grupo 6196"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_211",
    "data-name": "Elipse 211",
    cx: 80.801,
    cy: 80.801,
    r: 80.801,
    transform: "translate(567.277 152.984) rotate(-45)",
    fill: "#02daff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_808",
    "data-name": "Trazado 808",
    d: "M681.548,235.285a82.3,82.3,0,1,1,82.3-82.3A82.4,82.4,0,0,1,681.548,235.285Zm0-161.6a79.3,79.3,0,1,0,79.3,79.3A79.391,79.391,0,0,0,681.548,73.682Z",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6217",
    "data-name": "Grupo 6217",
    transform: "matrix(0.839, 0.545, -0.545, 0.839, 203.495, -409.645)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6214",
    "data-name": "Grupo 6214"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_224",
    "data-name": "Elipse 224",
    cx: 2.468,
    cy: 2.468,
    r: 2.468,
    transform: "translate(734.511 171.853)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6215",
    "data-name": "Grupo 6215"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_225",
    "data-name": "Elipse 225",
    cx: 1.943,
    cy: 1.943,
    r: 1.943,
    transform: "translate(743.628 164.023)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6216",
    "data-name": "Grupo 6216"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_859",
    "data-name": "Trazado 859",
    d: "M740.461,157.287a1.2,1.2,0,1,1-1.586.62A1.2,1.2,0,0,1,740.461,157.287Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7399",
    "data-name": "Grupo 7399",
    transform: "translate(2834.905 544.863)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7407",
    "data-name": "Grupo 7407",
    transform: "translate(-2245.631 -347.302)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7401",
    "data-name": "Grupo 7401",
    transform: "translate(1.631 1.053)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7400",
    "data-name": "Grupo 7400"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7399-2",
    "data-name": "Grupo 7399",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2560",
    "data-name": "Trazado 2560",
    d: "M-2220.365,2393.715l2.7,5.072h-2.7Z",
    transform: "translate(2220.365 -2365.366)",
    fill: "#ec1c24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2561",
    "data-name": "Trazado 2561",
    d: "M-2220.365,2383.942l3.032,5.7h-.336l-2.7-5.072Z",
    transform: "translate(2220.365 -2356.224)",
    fill: "#ec1c24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2562",
    "data-name": "Trazado 2562",
    d: "M-2220.365,2374.169l3.368,6.333h-.335l-3.032-5.7Z",
    transform: "translate(2220.365 -2347.082)",
    fill: "#ec1c24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2563",
    "data-name": "Trazado 2563",
    d: "M-2220.365,2364.4l3.7,6.964H-2217l-3.368-6.333Z",
    transform: "translate(2220.365 -2337.941)",
    fill: "#ec1c24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2564",
    "data-name": "Trazado 2564",
    d: "M-2220.365,2354.624l4.039,7.6h-.336l-3.7-6.964Z",
    transform: "translate(2220.365 -2328.799)",
    fill: "#ec1c24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2565",
    "data-name": "Trazado 2565",
    d: "M-2220.365,2344.851l4.374,8.226h-.335l-4.039-7.595Z",
    transform: "translate(2220.365 -2319.657)",
    fill: "#ec1c24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2566",
    "data-name": "Trazado 2566",
    d: "M-2220.365,2335.078l4.71,8.857h-.336l-4.374-8.226Z",
    transform: "translate(2220.365 -2310.515)",
    fill: "#ec1c24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2567",
    "data-name": "Trazado 2567",
    d: "M-2220.365,2325.306l5.045,9.488h-.335l-4.71-8.857Z",
    transform: "translate(2220.365 -2301.373)",
    fill: "#ec1d24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2568",
    "data-name": "Trazado 2568",
    d: "M-2220.365,2315.533l5.381,10.118h-.336l-5.045-9.488Z",
    transform: "translate(2220.365 -2292.231)",
    fill: "#ec1d24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2569",
    "data-name": "Trazado 2569",
    d: "M-2220.365,2305.76l5.716,10.75h-.335l-5.381-10.119Z",
    transform: "translate(2220.365 -2283.089)",
    fill: "#ec1d24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2570",
    "data-name": "Trazado 2570",
    d: "M-2220.365,2295.987l6.052,11.38h-.336l-5.716-10.749Z",
    transform: "translate(2220.365 -2273.948)",
    fill: "#ec1d24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2571",
    "data-name": "Trazado 2571",
    d: "M-2220.365,2286.215l6.387,12.011h-.335l-6.052-11.381Z",
    transform: "translate(2220.365 -2264.806)",
    fill: "#ec1d24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2572",
    "data-name": "Trazado 2572",
    d: "M-2220.365,2276.442l6.722,12.642h-.336l-6.387-12.011Z",
    transform: "translate(2220.365 -2255.664)",
    fill: "#ec1e24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2573",
    "data-name": "Trazado 2573",
    d: "M-2220.365,2266.669l7.058,13.273h-.335l-6.722-12.642Z",
    transform: "translate(2220.365 -2246.522)",
    fill: "#ec1e24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2574",
    "data-name": "Trazado 2574",
    d: "M-2220.365,2256.9l7.393,13.9h-.335l-7.058-13.273Z",
    transform: "translate(2220.365 -2237.38)",
    fill: "#ec1e24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2575",
    "data-name": "Trazado 2575",
    d: "M-2220.365,2247.124l7.729,14.535h-.335l-7.393-13.9Z",
    transform: "translate(2220.365 -2228.238)",
    fill: "#ec1f24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2576",
    "data-name": "Trazado 2576",
    d: "M-2220.365,2237.351l8.064,15.166h-.335l-7.729-14.535Z",
    transform: "translate(2220.365 -2219.096)",
    fill: "#ec1f24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2577",
    "data-name": "Trazado 2577",
    d: "M-2220.365,2227.578l8.4,15.8h-.336l-8.064-15.166Z",
    transform: "translate(2220.365 -2209.955)",
    fill: "#ec1f24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2578",
    "data-name": "Trazado 2578",
    d: "M-2220.365,2217.805l8.735,16.427h-.335l-8.4-15.8Z",
    transform: "translate(2220.365 -2200.813)",
    fill: "#ec2024"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2579",
    "data-name": "Trazado 2579",
    d: "M-2220.365,2208.032l9.071,17.058h-.335l-8.735-16.427Z",
    transform: "translate(2220.365 -2191.671)",
    fill: "#ec2024"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2580",
    "data-name": "Trazado 2580",
    d: "M-2220.365,2198.26l9.406,17.689h-.335l-9.071-17.058Z",
    transform: "translate(2220.365 -2182.529)",
    fill: "#ec2024"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2581",
    "data-name": "Trazado 2581",
    d: "M-2220.365,2188.487l9.742,18.32h-.335l-9.406-17.689Z",
    transform: "translate(2220.365 -2173.387)",
    fill: "#ed2124"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2582",
    "data-name": "Trazado 2582",
    d: "M-2220.365,2178.714l10.077,18.951h-.335l-9.742-18.32Z",
    transform: "translate(2220.365 -2164.245)",
    fill: "#ed2124"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2583",
    "data-name": "Trazado 2583",
    d: "M-2220.365,2168.942l10.413,19.582h-.335l-10.077-18.951Z",
    transform: "translate(2220.365 -2155.104)",
    fill: "#ed2124"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2584",
    "data-name": "Trazado 2584",
    d: "M-2220.365,2165.239l.2-.109,10.544,19.828h-.335l-10.413-19.582Z",
    transform: "translate(2220.365 -2151.537)",
    fill: "#ed2224"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2585",
    "data-name": "Trazado 2585",
    d: "M-2217.2,2163.114l.261-.139,10.617,19.967h-.335Z",
    transform: "translate(2217.4 -2149.522)",
    fill: "#ed2224"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2586",
    "data-name": "Trazado 2586",
    d: "M-2213.144,2160.96l.262-.139,10.691,20.106h-.335Z",
    transform: "translate(2213.61 -2147.507)",
    fill: "#ed2324"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2587",
    "data-name": "Trazado 2587",
    d: "M-2209.093,2158.806l.262-.139,10.765,20.245h-.335Z",
    transform: "translate(2209.821 -2145.492)",
    fill: "#ed2324"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2588",
    "data-name": "Trazado 2588",
    d: "M-2205.042,2156.651l.261-.139,10.839,20.384h-.336Z",
    transform: "translate(2206.031 -2143.476)",
    fill: "#ed2424"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2589",
    "data-name": "Trazado 2589",
    d: "M-2200.99,2154.5l.261-.139,10.913,20.523h-.335Z",
    transform: "translate(2202.241 -2141.461)",
    fill: "#ed2424"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2590",
    "data-name": "Trazado 2590",
    d: "M-2196.939,2152.343l.262-.139,10.987,20.662h-.335Z",
    transform: "translate(2198.452 -2139.446)",
    fill: "#ed2524"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2591",
    "data-name": "Trazado 2591",
    d: "M-2192.888,2150.189l.261-.139,11.061,20.8h-.335Z",
    transform: "translate(2194.662 -2137.431)",
    fill: "#ed2524"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2592",
    "data-name": "Trazado 2592",
    d: "M-2188.837,2148.034l.261-.139,11.135,20.94h-.335Z",
    transform: "translate(2190.872 -2135.416)",
    fill: "#ed2624"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2593",
    "data-name": "Trazado 2593",
    d: "M-2184.786,2145.88l.261-.139,11.209,21.079h-.335Z",
    transform: "translate(2187.083 -2133.401)",
    fill: "#ed2624"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2594",
    "data-name": "Trazado 2594",
    d: "M-2180.735,2143.726l.261-.139,11.283,21.218h-.335Z",
    transform: "translate(2183.293 -2131.385)",
    fill: "#ed2724"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2595",
    "data-name": "Trazado 2595",
    d: "M-2176.683,2141.572l.261-.139,11.357,21.357h-.335Z",
    transform: "translate(2179.503 -2129.37)",
    fill: "#ed2724"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2596",
    "data-name": "Trazado 2596",
    d: "M-2172.632,2139.417l.261-.139,11.431,21.5h-.335Z",
    transform: "translate(2175.713 -2127.354)",
    fill: "#ed2824"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2597",
    "data-name": "Trazado 2597",
    d: "M-2168.581,2137.263l.261-.139,11.5,21.636h-.335Z",
    transform: "translate(2171.924 -2125.34)",
    fill: "#ed2824"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2598",
    "data-name": "Trazado 2598",
    d: "M-2164.53,2135.109l.261-.139,11.579,21.775h-.335Z",
    transform: "translate(2168.134 -2123.325)",
    fill: "#ed2924"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2599",
    "data-name": "Trazado 2599",
    d: "M-2160.478,2132.955l.261-.139,11.653,21.914h-.335Z",
    transform: "translate(2164.344 -2121.309)",
    fill: "#ed2a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2600",
    "data-name": "Trazado 2600",
    d: "M-2156.427,2130.8l.261-.139,11.727,22.053h-.335Z",
    transform: "translate(2160.554 -2119.294)",
    fill: "#ee2a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2601",
    "data-name": "Trazado 2601",
    d: "M-2152.376,2128.646l.261-.139,11.8,22.192h-.335Z",
    transform: "translate(2156.765 -2117.279)",
    fill: "#ee2b24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2602",
    "data-name": "Trazado 2602",
    d: "M-2148.325,2126.492l.261-.139,11.875,22.331h-.335Z",
    transform: "translate(2152.975 -2115.264)",
    fill: "#ee2b24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2603",
    "data-name": "Trazado 2603",
    d: "M-2144.273,2124.338l.261-.139,11.949,22.47h-.336Z",
    transform: "translate(2149.185 -2113.248)",
    fill: "#ee2c24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2604",
    "data-name": "Trazado 2604",
    d: "M-2140.222,2122.183l.261-.139,12.022,22.609h-.335Z",
    transform: "translate(2145.396 -2111.234)",
    fill: "#ee2d24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2605",
    "data-name": "Trazado 2605",
    d: "M-2136.171,2120.029l.261-.139,12.1,22.748h-.335Z",
    transform: "translate(2141.606 -2109.218)",
    fill: "#ee2d24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2606",
    "data-name": "Trazado 2606",
    d: "M-2132.12,2117.875l.261-.139,12.171,22.887h-.335Z",
    transform: "translate(2137.817 -2107.203)",
    fill: "#ee2e24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2607",
    "data-name": "Trazado 2607",
    d: "M-2128.069,2115.72l.261-.139,12.245,23.026h-.335Z",
    transform: "translate(2134.027 -2105.188)",
    fill: "#ee2f24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2608",
    "data-name": "Trazado 2608",
    d: "M-2124.018,2113.566l.261-.139,12.319,23.166h-.336Z",
    transform: "translate(2130.237 -2103.172)",
    fill: "#ee2f24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2609",
    "data-name": "Trazado 2609",
    d: "M-2119.967,2111.412l.261-.139,12.392,23.3h-.335Z",
    transform: "translate(2126.448 -2101.158)",
    fill: "#ee3024"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2610",
    "data-name": "Trazado 2610",
    d: "M-2115.915,2109.258l.261-.139,12.466,23.443h-.335Z",
    transform: "translate(2122.658 -2099.143)",
    fill: "#ee3124"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2611",
    "data-name": "Trazado 2611",
    d: "M-2111.864,2107.1l.261-.139,12.54,23.583h-.335Z",
    transform: "translate(2118.868 -2097.127)",
    fill: "#ee3224"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2612",
    "data-name": "Trazado 2612",
    d: "M-2107.813,2104.949l.261-.139,12.614,23.722h-.335Z",
    transform: "translate(2115.079 -2095.112)",
    fill: "#ee3225"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2613",
    "data-name": "Trazado 2613",
    d: "M-2103.762,2102.795l.262-.139,12.688,23.861h-.336Z",
    transform: "translate(2111.289 -2093.096)",
    fill: "#ef3325"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2614",
    "data-name": "Trazado 2614",
    d: "M-2099.711,2100.641l.261-.139,12.762,24h-.335Z",
    transform: "translate(2107.5 -2091.082)",
    fill: "#ef3425"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2615",
    "data-name": "Trazado 2615",
    d: "M-2095.659,2098.487l.261-.139,12.836,24.139h-.336Z",
    transform: "translate(2103.71 -2089.066)",
    fill: "#ef3525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2616",
    "data-name": "Trazado 2616",
    d: "M-2091.608,2096.332l.261-.139,12.91,24.278h-.335Z",
    transform: "translate(2099.92 -2087.051)",
    fill: "#ef3525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2617",
    "data-name": "Trazado 2617",
    d: "M-2087.557,2094.178l.262-.139,12.984,24.417h-.335Z",
    transform: "translate(2096.13 -2085.036)",
    fill: "#ef3625"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2618",
    "data-name": "Trazado 2618",
    d: "M-2083.506,2092.024l.261-.139,13.058,24.556h-.335Z",
    transform: "translate(2092.341 -2083.021)",
    fill: "#ef3725"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2619",
    "data-name": "Trazado 2619",
    d: "M-2079.455,2089.869l.261-.139,13.132,24.7h-.335Z",
    transform: "translate(2088.551 -2081.005)",
    fill: "#ef3825"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2620",
    "data-name": "Trazado 2620",
    d: "M-2075.4,2087.715l.262-.139,13.206,24.834h-.335Z",
    transform: "translate(2084.761 -2078.99)",
    fill: "#ef3925"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2621",
    "data-name": "Trazado 2621",
    d: "M-2071.352,2085.561l.262-.139,13.28,24.973h-.335Z",
    transform: "translate(2080.972 -2076.975)",
    fill: "#ef3925"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2622",
    "data-name": "Trazado 2622",
    d: "M-2067.3,2083.407l.261-.139,13.354,25.112h-.335Z",
    transform: "translate(2077.182 -2074.96)",
    fill: "#ef3a25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2623",
    "data-name": "Trazado 2623",
    d: "M-2063.25,2081.253l.261-.139,13.428,25.251h-.335Z",
    transform: "translate(2073.392 -2072.945)",
    fill: "#ef3b25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2624",
    "data-name": "Trazado 2624",
    d: "M-2059.2,2079.1l.261-.139,13.5,25.39h-.335Z",
    transform: "translate(2069.603 -2070.93)",
    fill: "#ef3c25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2625",
    "data-name": "Trazado 2625",
    d: "M-2055.147,2076.944l.262-.139,13.575,25.529h-.335Z",
    transform: "translate(2065.813 -2068.914)",
    fill: "#f03d25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2626",
    "data-name": "Trazado 2626",
    d: "M-2051.1,2074.79l.261-.139,13.649,25.669h-.335Z",
    transform: "translate(2062.023 -2066.899)",
    fill: "#f03e25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2627",
    "data-name": "Trazado 2627",
    d: "M-2047.045,2072.635l.262-.139,13.723,25.808h-.335Z",
    transform: "translate(2058.233 -2064.884)",
    fill: "#f03e25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2628",
    "data-name": "Trazado 2628",
    d: "M-2042.994,2070.481l.262-.139,13.8,25.947h-.335Z",
    transform: "translate(2054.444 -2062.869)",
    fill: "#f03f25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2629",
    "data-name": "Trazado 2629",
    d: "M-2038.943,2068.327l.261-.139,13.871,26.086h-.335Z",
    transform: "translate(2050.654 -2060.854)",
    fill: "#f04025"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2630",
    "data-name": "Trazado 2630",
    d: "M-2034.891,2066.173l.261-.139,13.945,26.225h-.335Z",
    transform: "translate(2046.865 -2058.838)",
    fill: "#f04125"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2631",
    "data-name": "Trazado 2631",
    d: "M-2030.84,2064.018l.262-.139,14.019,26.364h-.335Z",
    transform: "translate(2043.075 -2056.823)",
    fill: "#f04225"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2632",
    "data-name": "Trazado 2632",
    d: "M-2026.789,2061.864l.262-.139,14.093,26.5h-.335Z",
    transform: "translate(2039.285 -2054.808)",
    fill: "#f04325"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2633",
    "data-name": "Trazado 2633",
    d: "M-2022.738,2059.71l.261-.139,14.167,26.642h-.335Z",
    transform: "translate(2035.495 -2052.793)",
    fill: "#f04425"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2634",
    "data-name": "Trazado 2634",
    d: "M-2018.687,2057.555l.262-.139,14.241,26.781h-.335Z",
    transform: "translate(2031.706 -2050.778)",
    fill: "#f04525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2635",
    "data-name": "Trazado 2635",
    d: "M-2014.635,2055.4l.262-.139,14.315,26.92h-.335Z",
    transform: "translate(2027.916 -2048.762)",
    fill: "#f14625"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2636",
    "data-name": "Trazado 2636",
    d: "M-2010.584,2053.247l.261-.139,14.389,27.059h-.336Z",
    transform: "translate(2024.126 -2046.747)",
    fill: "#f14725"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2637",
    "data-name": "Trazado 2637",
    d: "M-2006.533,2051.093l.261-.139,14.463,27.2h-.336Z",
    transform: "translate(2020.337 -2044.732)",
    fill: "#f14825"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2638",
    "data-name": "Trazado 2638",
    d: "M-2002.482,2048.938l.262-.139,14.537,27.337h-.335Z",
    transform: "translate(2016.547 -2042.717)",
    fill: "#f14925"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2639",
    "data-name": "Trazado 2639",
    d: "M-1998.431,2046.784l.262-.139,14.611,27.476h-.335Z",
    transform: "translate(2012.757 -2040.702)",
    fill: "#f14a25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2640",
    "data-name": "Trazado 2640",
    d: "M-1994.379,2044.63l.261-.139,14.685,27.616h-.335Z",
    transform: "translate(2008.968 -2038.686)",
    fill: "#f14b25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2641",
    "data-name": "Trazado 2641",
    d: "M-1990.328,2042.476l.261-.139,14.759,27.755h-.336Z",
    transform: "translate(2005.178 -2036.671)",
    fill: "#f14c25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2642",
    "data-name": "Trazado 2642",
    d: "M-1986.277,2040.322l.262-.139,14.833,27.893h-.335Z",
    transform: "translate(2001.389 -2034.656)",
    fill: "#f14d25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2643",
    "data-name": "Trazado 2643",
    d: "M-1982.226,2038.167l.261-.139,14.907,28.032h-.335Z",
    transform: "translate(1997.599 -2032.641)",
    fill: "#f14e25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2644",
    "data-name": "Trazado 2644",
    d: "M-1978.175,2036.013l.261-.139,14.981,28.172h-.335Z",
    transform: "translate(1993.809 -2030.626)",
    fill: "#f24f25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2645",
    "data-name": "Trazado 2645",
    d: "M-1974.124,2033.859l.262-.139,15.055,28.311h-.336Z",
    transform: "translate(1990.02 -2028.611)",
    fill: "#f25025"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2646",
    "data-name": "Trazado 2646",
    d: "M-1970.072,2031.7l.262-.139,15.128,28.45h-.335Z",
    transform: "translate(1986.23 -2026.595)",
    fill: "#f25125"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2647",
    "data-name": "Trazado 2647",
    d: "M-1966.021,2029.55l.261-.139,15.2,28.589h-.335Z",
    transform: "translate(1982.44 -2024.58)",
    fill: "#f25225"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2648",
    "data-name": "Trazado 2648",
    d: "M-1961.97,2027.4l.262-.139,15.2,28.592-.255.136h-.008Z",
    transform: "translate(1978.65 -2022.565)",
    fill: "#f25325"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_486",
    "data-name": "Rect\\xE1ngulo 486",
    width: 0.296,
    height: 32.383,
    transform: "translate(16.942 4.692) rotate(-28.002)",
    fill: "#f25425"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_487",
    "data-name": "Rect\\xE1ngulo 487",
    width: 0.296,
    height: 32.383,
    transform: "translate(17.203 4.553) rotate(-28.003)",
    fill: "#f25525"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_488",
    "data-name": "Rect\\xE1ngulo 488",
    width: 0.296,
    height: 32.383,
    transform: "translate(17.465 4.414) rotate(-28.002)",
    fill: "#f25625"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_489",
    "data-name": "Rect\\xE1ngulo 489",
    width: 0.296,
    height: 32.383,
    transform: "translate(17.727 4.275) rotate(-28.002)",
    fill: "#f25725"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_490",
    "data-name": "Rect\\xE1ngulo 490",
    width: 0.296,
    height: 32.383,
    transform: "translate(17.988 4.136) rotate(-28.003)",
    fill: "#f35825"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_491",
    "data-name": "Rect\\xE1ngulo 491",
    width: 0.296,
    height: 32.383,
    transform: "matrix(0.883, -0.47, 0.47, 0.883, 18.25, 3.997)",
    fill: "#f35925"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_492",
    "data-name": "Rect\\xE1ngulo 492",
    width: 0.296,
    height: 32.383,
    transform: "translate(18.511 3.858) rotate(-28.003)",
    fill: "#f35a25"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_493",
    "data-name": "Rect\\xE1ngulo 493",
    width: 0.296,
    height: 32.383,
    transform: "translate(18.773 3.718) rotate(-28.002)",
    fill: "#f35c25"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_494",
    "data-name": "Rect\\xE1ngulo 494",
    width: 0.296,
    height: 32.383,
    transform: "translate(19.034 3.579) rotate(-28.003)",
    fill: "#f35d25"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_495",
    "data-name": "Rect\\xE1ngulo 495",
    width: 0.296,
    height: 32.383,
    transform: "translate(19.296 3.44) rotate(-28.003)",
    fill: "#f35e26"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_496",
    "data-name": "Rect\\xE1ngulo 496",
    width: 0.296,
    height: 32.383,
    transform: "translate(19.557 3.301) rotate(-28.002)",
    fill: "#f35f26"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_497",
    "data-name": "Rect\\xE1ngulo 497",
    width: 0.296,
    height: 32.383,
    transform: "translate(19.819 3.162) rotate(-28.003)",
    fill: "#f36026"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_498",
    "data-name": "Rect\\xE1ngulo 498",
    width: 0.296,
    height: 32.383,
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 20.081, 3.023)",
    fill: "#f46126"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_499",
    "data-name": "Rect\\xE1ngulo 499",
    width: 0.296,
    height: 32.383,
    transform: "translate(20.342 2.884) rotate(-28.003)",
    fill: "#f46226"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_500",
    "data-name": "Rect\\xE1ngulo 500",
    width: 0.296,
    height: 32.383,
    transform: "translate(20.603 2.745) rotate(-28.003)",
    fill: "#f46426"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_501",
    "data-name": "Rect\\xE1ngulo 501",
    width: 0.296,
    height: 32.383,
    transform: "translate(20.865 2.606) rotate(-28.002)",
    fill: "#f46526"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_502",
    "data-name": "Rect\\xE1ngulo 502",
    width: 0.296,
    height: 32.383,
    transform: "translate(21.126 2.467) rotate(-28.003)",
    fill: "#f46626"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_503",
    "data-name": "Rect\\xE1ngulo 503",
    width: 0.296,
    height: 32.383,
    transform: "translate(21.388 2.328) rotate(-28.002)",
    fill: "#f46726"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_504",
    "data-name": "Rect\\xE1ngulo 504",
    width: 0.296,
    height: 32.383,
    transform: "translate(21.649 2.189) rotate(-28.003)",
    fill: "#f46826"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_505",
    "data-name": "Rect\\xE1ngulo 505",
    width: 0.296,
    height: 32.383,
    transform: "translate(21.911 2.05) rotate(-28.003)",
    fill: "#f46a26"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_506",
    "data-name": "Rect\\xE1ngulo 506",
    width: 0.296,
    height: 32.383,
    transform: "translate(22.173 1.911) rotate(-28.002)",
    fill: "#f56b26"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_507",
    "data-name": "Rect\\xE1ngulo 507",
    width: 0.296,
    height: 32.383,
    transform: "translate(22.434 1.772) rotate(-28.003)",
    fill: "#f56c26"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_508",
    "data-name": "Rect\\xE1ngulo 508",
    width: 0.296,
    height: 32.383,
    transform: "translate(22.696 1.632) rotate(-28.002)",
    fill: "#f56d26"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_509",
    "data-name": "Rect\\xE1ngulo 509",
    width: 0.296,
    height: 32.383,
    transform: "translate(22.957 1.493) rotate(-28.003)",
    fill: "#f56f26"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_510",
    "data-name": "Rect\\xE1ngulo 510",
    width: 0.296,
    height: 32.383,
    transform: "translate(23.218 1.354) rotate(-28.003)",
    fill: "#f57026"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_511",
    "data-name": "Rect\\xE1ngulo 511",
    width: 0.296,
    height: 32.383,
    transform: "translate(23.48 1.215) rotate(-28.002)",
    fill: "#f57126"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_512",
    "data-name": "Rect\\xE1ngulo 512",
    width: 0.296,
    height: 32.383,
    transform: "translate(23.742 1.076) rotate(-28.003)",
    fill: "#f57226"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_513",
    "data-name": "Rect\\xE1ngulo 513",
    width: 0.296,
    height: 32.383,
    transform: "translate(24.003 0.937) rotate(-28.002)",
    fill: "#f67426"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_514",
    "data-name": "Rect\\xE1ngulo 514",
    width: 0.296,
    height: 32.383,
    transform: "translate(24.265 0.798) rotate(-28.003)",
    fill: "#f67526"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_515",
    "data-name": "Rect\\xE1ngulo 515",
    width: 0.296,
    height: 32.383,
    transform: "translate(24.526 0.659) rotate(-28.003)",
    fill: "#f67626"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_516",
    "data-name": "Rect\\xE1ngulo 516",
    width: 0.296,
    height: 32.383,
    transform: "translate(24.788 0.52) rotate(-28.002)",
    fill: "#f67726"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_517",
    "data-name": "Rect\\xE1ngulo 517",
    width: 0.296,
    height: 32.383,
    transform: "translate(25.049 0.381) rotate(-28.003)",
    fill: "#f67926"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_518",
    "data-name": "Rect\\xE1ngulo 518",
    width: 0.296,
    height: 32.383,
    transform: "translate(25.311 0.242) rotate(-28.002)",
    fill: "#f67a26"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_519",
    "data-name": "Rect\\xE1ngulo 519",
    width: 0.296,
    height: 32.383,
    transform: "translate(25.572 0.103) rotate(-28.003)",
    fill: "#f67b26"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_520",
    "data-name": "Rect\\xE1ngulo 520",
    width: 0.296,
    height: 32.383,
    transform: "translate(25.834 -0.036) rotate(-28.003)",
    fill: "#f77d26"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_521",
    "data-name": "Rect\\xE1ngulo 521",
    width: 0.296,
    height: 32.383,
    transform: "translate(26.096 -0.175) rotate(-28.002)",
    fill: "#f77e26"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_522",
    "data-name": "Rect\\xE1ngulo 522",
    width: 0.296,
    height: 32.383,
    transform: "translate(26.357 -0.314) rotate(-28.003)",
    fill: "#f77f26"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_523",
    "data-name": "Rect\\xE1ngulo 523",
    width: 0.296,
    height: 32.383,
    transform: "translate(26.619 -0.454) rotate(-28.002)",
    fill: "#f78126"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_524",
    "data-name": "Rect\\xE1ngulo 524",
    width: 0.296,
    height: 32.383,
    transform: "translate(26.88 -0.593) rotate(-28.003)",
    fill: "#f78226"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_525",
    "data-name": "Rect\\xE1ngulo 525",
    width: 0.296,
    height: 32.383,
    transform: "translate(27.141 -0.732) rotate(-28.003)",
    fill: "#f78426"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_526",
    "data-name": "Rect\\xE1ngulo 526",
    width: 0.296,
    height: 32.383,
    transform: "translate(27.403 -0.871) rotate(-28.002)",
    fill: "#f78526"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_527",
    "data-name": "Rect\\xE1ngulo 527",
    width: 0.296,
    height: 32.383,
    transform: "translate(27.664 -1.01) rotate(-28.003)",
    fill: "#f88626"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_528",
    "data-name": "Rect\\xE1ngulo 528",
    width: 0.296,
    height: 32.383,
    transform: "translate(27.926 -1.149) rotate(-28.002)",
    fill: "#f88826"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_529",
    "data-name": "Rect\\xE1ngulo 529",
    width: 0.296,
    height: 32.383,
    transform: "translate(28.187 -1.288) rotate(-28.003)",
    fill: "#f88927"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_530",
    "data-name": "Rect\\xE1ngulo 530",
    width: 0.296,
    height: 32.383,
    transform: "translate(28.449 -1.427) rotate(-28.003)",
    fill: "#f88a27"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_531",
    "data-name": "Rect\\xE1ngulo 531",
    width: 0.296,
    height: 32.383,
    transform: "translate(28.711 -1.566) rotate(-28.002)",
    fill: "#f88c27"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_532",
    "data-name": "Rect\\xE1ngulo 532",
    width: 0.296,
    height: 32.383,
    transform: "translate(28.972 -1.705) rotate(-28.003)",
    fill: "#f88d27"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_533",
    "data-name": "Rect\\xE1ngulo 533",
    width: 0.296,
    height: 32.383,
    transform: "translate(29.234 -1.844) rotate(-28.002)",
    fill: "#f98f27"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_534",
    "data-name": "Rect\\xE1ngulo 534",
    width: 0.296,
    height: 32.383,
    transform: "translate(29.495 -1.983) rotate(-28.003)",
    fill: "#f99027"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_535",
    "data-name": "Rect\\xE1ngulo 535",
    width: 0.296,
    height: 32.383,
    transform: "translate(29.757 -2.122) rotate(-28.003)",
    fill: "#f99227"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_536",
    "data-name": "Rect\\xE1ngulo 536",
    width: 0.296,
    height: 32.383,
    transform: "translate(30.018 -2.261) rotate(-28.002)",
    fill: "#f99327"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_537",
    "data-name": "Rect\\xE1ngulo 537",
    width: 0.296,
    height: 32.383,
    transform: "translate(30.28 -2.4) rotate(-28.003)",
    fill: "#f99427"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_538",
    "data-name": "Rect\\xE1ngulo 538",
    width: 0.296,
    height: 32.383,
    transform: "translate(30.541 -2.54) rotate(-28.002)",
    fill: "#f99627"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_539",
    "data-name": "Rect\\xE1ngulo 539",
    width: 0.296,
    height: 32.383,
    transform: "translate(30.803 -2.679) rotate(-28.003)",
    fill: "#f99727"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_540",
    "data-name": "Rect\\xE1ngulo 540",
    width: 0.296,
    height: 32.383,
    transform: "translate(31.064 -2.818) rotate(-28.002)",
    fill: "#fa9927"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_541",
    "data-name": "Rect\\xE1ngulo 541",
    width: 0.296,
    height: 32.383,
    transform: "translate(31.326 -2.957) rotate(-28.003)",
    fill: "#fa9a27"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_542",
    "data-name": "Rect\\xE1ngulo 542",
    width: 0.296,
    height: 32.383,
    transform: "translate(31.587 -3.096) rotate(-28.003)",
    fill: "#fa9c27"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_543",
    "data-name": "Rect\\xE1ngulo 543",
    width: 0.296,
    height: 32.383,
    transform: "translate(31.849 -3.235) rotate(-28.002)",
    fill: "#fa9d27"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_544",
    "data-name": "Rect\\xE1ngulo 544",
    width: 0.296,
    height: 32.383,
    transform: "translate(32.11 -3.374) rotate(-28.003)",
    fill: "#fa9f27"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_545",
    "data-name": "Rect\\xE1ngulo 545",
    width: 0.296,
    height: 32.383,
    transform: "translate(32.372 -3.513) rotate(-28.002)",
    fill: "#faa027"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_546",
    "data-name": "Rect\\xE1ngulo 546",
    width: 0.296,
    height: 32.383,
    transform: "translate(32.633 -3.652) rotate(-28.003)",
    fill: "#fba227"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_547",
    "data-name": "Rect\\xE1ngulo 547",
    width: 0.296,
    height: 32.383,
    transform: "translate(32.895 -3.791) rotate(-28.003)",
    fill: "#fba327"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2649",
    "data-name": "Trazado 2649",
    d: "M-1706.744,1892.339l.176-.094h.11l15.18,28.547-.261.139Z",
    transform: "translate(1739.901 -1896.269)",
    fill: "#fba527"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2650",
    "data-name": "Trazado 2650",
    d: "M-1701.981,1892.246l15.106,28.407-.262.139-15.18-28.547Z",
    transform: "translate(1735.759 -1896.269)",
    fill: "#fba627"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2651",
    "data-name": "Trazado 2651",
    d: "M-1696.785,1892.246l15.032,28.268-.262.139-15.106-28.407Z",
    transform: "translate(1730.898 -1896.269)",
    fill: "#fba827"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2652",
    "data-name": "Trazado 2652",
    d: "M-1691.588,1892.246l14.958,28.129-.261.139-15.032-28.268Z",
    transform: "translate(1726.036 -1896.269)",
    fill: "#fbaa27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2653",
    "data-name": "Trazado 2653",
    d: "M-1686.391,1892.246l14.884,27.99-.262.139-14.958-28.129Z",
    transform: "translate(1721.176 -1896.269)",
    fill: "#fcab27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2654",
    "data-name": "Trazado 2654",
    d: "M-1681.194,1892.246l14.81,27.851-.261.139-14.884-27.99Z",
    transform: "translate(1716.314 -1896.269)",
    fill: "#fcad27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2655",
    "data-name": "Trazado 2655",
    d: "M-1676,1892.246l14.736,27.712-.261.139-14.81-27.851Z",
    transform: "translate(1711.453 -1896.269)",
    fill: "#fcae27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2656",
    "data-name": "Trazado 2656",
    d: "M-1670.8,1892.246l14.662,27.573-.261.139-14.736-27.712Z",
    transform: "translate(1706.591 -1896.269)",
    fill: "#fcb027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2657",
    "data-name": "Trazado 2657",
    d: "M-1665.6,1892.246l14.588,27.434-.262.139-14.662-27.573Z",
    transform: "translate(1701.73 -1896.269)",
    fill: "#fcb127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2658",
    "data-name": "Trazado 2658",
    d: "M-1660.407,1892.246l14.384,27.05v.315l-.131.07-14.588-27.434Z",
    transform: "translate(1696.869 -1896.269)",
    fill: "#fcb327"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2659",
    "data-name": "Trazado 2659",
    d: "M-1655.211,1892.246l14.048,26.419v.631l-14.384-27.05Z",
    transform: "translate(1692.008 -1896.269)",
    fill: "#fdb528"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2660",
    "data-name": "Trazado 2660",
    d: "M-1650.014,1892.246l13.713,25.788v.631l-14.048-26.419Z",
    transform: "translate(1687.146 -1896.269)",
    fill: "#fdb628"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2661",
    "data-name": "Trazado 2661",
    d: "M-1644.817,1892.246l13.377,25.157v.631l-13.713-25.788Z",
    transform: "translate(1682.285 -1896.269)",
    fill: "#fdb828"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2662",
    "data-name": "Trazado 2662",
    d: "M-1639.62,1892.246l13.042,24.526v.631l-13.377-25.157Z",
    transform: "translate(1677.424 -1896.269)",
    fill: "#fdb928"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2663",
    "data-name": "Trazado 2663",
    d: "M-1634.424,1892.246l12.707,23.9v.631l-13.042-24.526Z",
    transform: "translate(1672.562 -1896.269)",
    fill: "#fdbb28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2664",
    "data-name": "Trazado 2664",
    d: "M-1629.227,1892.246l12.371,23.264v.631l-12.707-23.9Z",
    transform: "translate(1667.701 -1896.269)",
    fill: "#febd28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2665",
    "data-name": "Trazado 2665",
    d: "M-1624.03,1892.246l12.036,22.634v.631l-12.371-23.264Z",
    transform: "translate(1662.84 -1896.269)",
    fill: "#febe28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2666",
    "data-name": "Trazado 2666",
    d: "M-1618.833,1892.246l11.7,22v.631l-12.036-22.634Z",
    transform: "translate(1657.979 -1896.269)",
    fill: "#fec028"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2667",
    "data-name": "Trazado 2667",
    d: "M-1613.637,1892.246l11.365,21.372v.631l-11.7-22Z",
    transform: "translate(1653.117 -1896.269)",
    fill: "#fec228"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2668",
    "data-name": "Trazado 2668",
    d: "M-1608.44,1892.246l11.029,20.741v.631l-11.365-21.372Z",
    transform: "translate(1648.256 -1896.269)",
    fill: "#fec328"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2669",
    "data-name": "Trazado 2669",
    d: "M-1603.243,1892.246l10.694,20.11v.631l-11.029-20.741Z",
    transform: "translate(1643.395 -1896.269)",
    fill: "#fec528"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2670",
    "data-name": "Trazado 2670",
    d: "M-1598.046,1892.246l10.358,19.479v.631l-10.694-20.11Z",
    transform: "translate(1638.534 -1896.269)",
    fill: "#ffc728"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2671",
    "data-name": "Trazado 2671",
    d: "M-1592.85,1892.246l10.023,18.848v.631l-10.358-19.479Z",
    transform: "translate(1633.672 -1896.269)",
    fill: "#ffc828"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2672",
    "data-name": "Trazado 2672",
    d: "M-1587.653,1892.246l9.687,18.217v.631l-10.023-18.848Z",
    transform: "translate(1628.811 -1896.269)",
    fill: "#ffca28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2673",
    "data-name": "Trazado 2673",
    d: "M-1573.1,1910.463l-9.687-18.217h9.687Z",
    transform: "translate(1623.95 -1896.269)",
    fill: "#ffca28"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7403",
    "data-name": "Grupo 7403",
    transform: "translate(1.631 1.053)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7402",
    "data-name": "Grupo 7402"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2674",
    "data-name": "Trazado 2674",
    d: "M-2211.288,1980.275c9.072-7.869,7.713-17.061,17.665-21.38,12.455-5.405,20.812,6.792,20.812,6.792a19.878,19.878,0,0,1,.356,3.3,22.181,22.181,0,0,0-.266-6.241s-8.358-12.2-20.812-6.792-7.192,18.443-26.832,26.967A34.309,34.309,0,0,1-2211.288,1980.275Z",
    transform: "translate(2220.366 -1954.574)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7404",
    "data-name": "Grupo 7404",
    transform: "translate(1.631 18.414)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2675",
    "data-name": "Trazado 2675",
    d: "M-2172.952,2223.518a15.18,15.18,0,0,1-7.022,5.872c-10.3,4.471-16.389-4.056-29.3-2.316a32.642,32.642,0,0,1-11.093,7.431c19.64-8.523,25.936,5.072,38.39-.333A15.118,15.118,0,0,0-2172.952,2223.518Z",
    transform: "translate(2220.366 -2223.518)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7405",
    "data-name": "Grupo 7405",
    transform: "translate(17.182 3.083)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2676",
    "data-name": "Trazado 2676",
    d: "M-1979.463,2005.888c11.434-4.962,19.171,2.949,26.422-.2s4.63-13.295,4.63-13.295-5.622-8.845-12.873-5.7S-1968.029,2000.926-1979.463,2005.888Z",
    transform: "translate(1979.463 -1986.02)",
    fill: "#ffd553"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7406",
    "data-name": "Grupo 7406",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2677",
    "data-name": "Trazado 2677",
    d: "M-2211.875,1969.733a31.914,31.914,0,0,1-8.9-1.685c-6-1.733-12.793-3.7-23.376.9a1.06,1.06,0,0,1-1.395-.55,1.062,1.062,0,0,1-.087-.421,1.06,1.06,0,0,1,.638-.973c10.6-4.6,13.907-10.682,16.826-16.048,2.428-4.464,4.722-8.681,10.578-11.222a16.363,16.363,0,0,1,16.077,1.453,23.338,23.338,0,0,1,6.032,5.712,1.056,1.056,0,0,1,.16.369,23.343,23.343,0,0,1,.053,8.307,16.364,16.364,0,0,1-9.919,12.735A16.48,16.48,0,0,1-2211.875,1969.733Zm-19.8-5.766a39.72,39.72,0,0,1,11.494,2.045c4.819,1.393,8.981,2.6,14.153.351,10.752-4.666,8.987-16.743,8.679-18.441-1.07-1.466-8.545-10.957-19.394-6.248-5.187,2.251-7.213,5.977-9.56,10.291-2.18,4.008-4.565,8.394-9.762,12.349A28.225,28.225,0,0,1-2231.678,1963.966Z",
    transform: "translate(2245.631 -1938.268)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7408",
    "data-name": "Grupo 7408",
    transform: "translate(-2132.192 -401.684)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2678",
    "data-name": "Trazado 2678",
    d: "M-488.373,1095.848s13.767,5.785,16.1,9.362-6.223,3.664-6.223,3.664",
    transform: "translate(488.373 -1095.848)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7409",
    "data-name": "Grupo 7409",
    transform: "translate(-2133.415 -402.906)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2679",
    "data-name": "Trazado 2679",
    d: "M-496.205,1092.383a1.222,1.222,0,0,1-.974-.484l-9.879-13.026a1.222,1.222,0,0,1,.008-1.488,1.222,1.222,0,0,1,1.439-.378c1.445.607,14.184,6.04,16.651,9.821a2.8,2.8,0,0,1,.3,3c-1.238,2.314-6.083,2.542-7.538,2.557Zm-6.013-11.174,6.606,8.712c2.288-.109,4.49-.665,4.8-1.248.03-.055-.029-.252-.2-.508C-492.174,1086.375-497.462,1083.468-502.218,1081.209Z",
    transform: "translate(507.306 -1076.912)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7417",
    "data-name": "Grupo 7417",
    transform: "translate(-2200.404 -435.243)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7410",
    "data-name": "Grupo 7410",
    transform: "translate(1.213 1.212)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2680",
    "data-name": "Trazado 2680",
    d: "M-1517.018,596.773c-5.348,4.008-10.249,23.093-9.01,34.47s21.349,12.229,32.85,11.86,11.461-26.373,11.31-33.339C-1482.1,598.886-1509.094,590.834-1517.018,596.773Z",
    transform: "translate(1526.222 -594.759)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7411",
    "data-name": "Grupo 7411",
    transform: "translate(1.213 1.546)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2681",
    "data-name": "Trazado 2681",
    d: "M-1493.177,647.952c-11.5.369-31.61-.484-32.851-11.861a37.546,37.546,0,0,1-.182-4.814c3.176,2.5,7.6.275,8.135-2.778,3.295-18.848,10.314-26.081,13.709-28.557,10.347,1.45,22.344,7.434,22.5,14.671C-1481.715,621.579-1481.676,647.583-1493.177,647.952Z",
    transform: "translate(1526.22 -599.943)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7412",
    "data-name": "Grupo 7412",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2682",
    "data-name": "Trazado 2682",
    d: "M-1514.77,626.835c-13.9,0-28.909-2.484-30.056-13.016-1.2-11.006,3.362-30.986,9.492-35.581,5.436-4.074,17.975-2.129,26.476,2.008,6.759,3.29,10.534,7.529,10.629,11.935.276,12.759-.98,34.218-12.493,34.587C-1512.051,626.811-1513.406,626.835-1514.77,626.835Zm-11.671-48.425c-3.164,0-5.817.578-7.427,1.785h0c-4.938,3.7-9.72,22.407-8.528,33.36,1.112,10.218,20.273,11.134,31.6,10.771,10.034-.322,10.289-24.644,10.127-32.091-.074-3.394-3.447-6.962-9.256-9.79A39.8,39.8,0,0,0-1526.441,578.41Zm-8.16.807h0Z",
    transform: "translate(1545.018 -575.991)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7413",
    "data-name": "Grupo 7413",
    transform: "translate(2.434 20.131)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2683",
    "data-name": "Trazado 2683",
    d: "M-1498.2,890.025l-5.1-2.035a2.064,2.064,0,0,0-2.764,1.4c-1.072,4.136-2.724,12.709,1.438,14.465,5.044,2.127,6.832-3.692,7.719-11.686A2.063,2.063,0,0,0-1498.2,890.025Z",
    transform: "translate(1507.31 -887.842)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7414",
    "data-name": "Grupo 7414",
    transform: "translate(2.44 22.38)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2684",
    "data-name": "Trazado 2684",
    d: "M-1496.841,924.743c-.868,8-2.643,13.821-7.691,11.7-2.074-.866-2.711-3.43-2.694-6.293a3.69,3.69,0,0,0,1.868,1.807c4.52,1.893,6.418-2.577,7.384-9.277A2.043,2.043,0,0,1-1496.841,924.743Z",
    transform: "translate(1507.227 -922.683)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7415",
    "data-name": "Grupo 7415",
    transform: "translate(1.29 19.007)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2685",
    "data-name": "Trazado 2685",
    d: "M-1519.251,889.129a6.178,6.178,0,0,1-2.382-.527c-4.614-1.933-3.7-9.65-2.129-15.784a3.189,3.189,0,0,1,1.641-2.047,3.2,3.2,0,0,1,2.63-.124l5.109,2.023a3.2,3.2,0,0,1,2,3.309c-.8,7.346-2.184,11.1-4.635,12.544A4.325,4.325,0,0,1-1519.251,889.129Zm-1.419-16.449a.931.931,0,0,0-.425.1.919.919,0,0,0-.478.6c-1.434,5.586-1.974,11.97.813,13.138a2.8,2.8,0,0,0,2.6.058c2.521-1.487,3.286-8.528,3.537-10.841a.934.934,0,0,0-.587-.964l-5.109-2.023A.943.943,0,0,0-1520.67,872.68Z",
    transform: "translate(1525.041 -870.422)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7416",
    "data-name": "Grupo 7416",
    transform: "translate(7.932 3.138)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2686",
    "data-name": "Trazado 2686",
    d: "M-1420.411,624.708l6.014,2.778c2,.94,4,1.87,5.984,2.881a.612.612,0,0,1,.268.822.612.612,0,0,1-.769.292l-.01,0c-2.026-.8-4.105-1.549-6.173-2.3l-6.225-2.2-.011,0a1.224,1.224,0,0,1-.745-1.562,1.224,1.224,0,0,1,1.562-.745C-1420.48,624.677-1420.444,624.692-1420.411,624.708Z",
    transform: "translate(1422.148 -624.594)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7418",
    "data-name": "Grupo 7418",
    transform: "translate(-2146.909 -450.958)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2687",
    "data-name": "Trazado 2687",
    d: "M-667.775,347.833c-1.983,6.765-17.044,19.293-38.651,19.92a58.2,58.2,0,0,1-6.447-.165l-1.928-8.235-1.543-6.591s3.355-.611,7.942-1.83a97.22,97.22,0,0,0,12.131-4.009,35.722,35.722,0,0,0,10.032-5.836s.138-6.777,2.06-7.468c2.347-.843,4.085,3.923,4.085,3.923s5.335-5.491,8.449-4.959C-667.017,333.371-665.6,340.414-667.775,347.833Z",
    transform: "translate(716.344 -332.546)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7419",
    "data-name": "Grupo 7419",
    transform: "translate(-2146.909 -441.202)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2688",
    "data-name": "Trazado 2688",
    d: "M-666.8,483.677a24.387,24.387,0,0,1-.972,5.531c-2.176,7.419-20.078,21.771-45.1,19.755l-3.471-14.826s1.042-.189,2.756-.568l4.057,7.858C-688.865,507.652-670.2,491.31-666.8,483.677Z",
    transform: "translate(716.344 -483.677)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7420",
    "data-name": "Grupo 7420",
    transform: "translate(-2148.13 -452.179)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2689",
    "data-name": "Trazado 2689",
    d: "M-725.827,351.317q-2.377,0-4.843-.2a1.222,1.222,0,0,1-1.12-1.316,1.224,1.224,0,0,1,1.316-1.12c24.675,1.988,41.9-12.334,43.826-18.883,1.372-4.674,1.237-9.328-.342-11.856a3.725,3.725,0,0,0-2.561-1.844c-1.706-.291-5.336,2.52-7.368,4.608l-1.358,1.4-.667-1.829c-.538-1.463-1.773-3.422-2.5-3.2-.606.432-1.21,3.443-1.271,6.348l-.011.527-.39.354c-8.706,7.885-29.809,11.81-30.7,11.974a1.223,1.223,0,0,1-1.422-.983,1.222,1.222,0,0,1,.983-1.422c.209-.038,20.67-3.844,29.116-11.042.1-2.507.581-7.232,2.853-8.049,2.306-.831,3.983,1.337,4.891,3,1.956-1.774,5.529-4.558,8.263-4.093a6.149,6.149,0,0,1,4.224,2.959c1.962,3.141,2.2,8.445.614,13.84C-686.52,338.048-702.868,351.316-725.827,351.317Zm24.39-34.248",
    transform: "translate(735.266 -313.64)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7421",
    "data-name": "Grupo 7421",
    transform: "translate(-2184.327 -438.159)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2690",
    "data-name": "Trazado 2690",
    d: "M-1232.426,582.355s-30.254,11.7-40.869,10.863-22.043-2.518-22.67-22.651c-.388-12.516,5.8-24.83,10.545-32.353a74.53,74.53,0,0,1,5.237-7.392l29.212,1.491s.113,1.54.348,4.095c.146,1.6.342,3.584.59,5.839.354,3.239.813,7.025,1.387,10.982a167.859,167.859,0,0,0,3.484,18.016C-1244.536,573.622-1234.562,574.273-1232.426,582.355Z",
    transform: "translate(1295.982 -530.822)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7422",
    "data-name": "Grupo 7422",
    transform: "translate(-2185.54 -438.502)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2691",
    "data-name": "Trazado 2691",
    d: "M-1266.875,540.1a88.706,88.706,0,0,1,2.352,10.765c.642,3.6,1.215,7.2,1.959,10.761.189.89.391,1.775.6,2.659l.325,1.32.083.33.005.02v-.012a.034.034,0,0,0,0-.015.039.039,0,0,0-.011-.011l.009.005c.006,0,0,.008.009.019a.426.426,0,0,1,.046.046c.015.03.092.079.134.121a5.951,5.951,0,0,0,.964.58c.376.192.781.379,1.2.567.827.375,1.687.759,2.538,1.19a18.041,18.041,0,0,1,4.828,3.354,12,12,0,0,1,1.859,2.428,11.779,11.779,0,0,1,1.169,2.837l.285,1.062-1.026.391c-4.811,1.832-9.639,3.53-14.522,5.126s-9.806,3.066-14.837,4.254a66.969,66.969,0,0,1-7.68,1.407,23.415,23.415,0,0,1-4.032.169c-.357-.01-.663-.043-.987-.068l-.964-.084c-.644-.059-1.29-.121-1.937-.2a33.614,33.614,0,0,1-7.756-1.7,19.075,19.075,0,0,1-3.669-1.8,16.321,16.321,0,0,1-3.178-2.643,17.105,17.105,0,0,1-2.4-3.344,20.656,20.656,0,0,1-1.613-3.723l-.161-.478-.135-.483-.267-.967-.219-.974-.108-.487-.086-.489-.171-.979c-.051-.326-.087-.654-.131-.981-.095-.654-.15-1.308-.2-1.962a41.7,41.7,0,0,1,.069-7.882,49,49,0,0,1,1.464-7.718,69.867,69.867,0,0,1,5.857-14.435,67.022,67.022,0,0,1,3.9-6.725,23.927,23.927,0,0,1,5.254-5.772.419.419,0,0,1,.586.085.419.419,0,0,1,.046.423l-.007.015a57.725,57.725,0,0,1-3.715,6.659c-1.308,2.151-2.721,4.243-3.9,6.468a66.9,66.9,0,0,0-5.66,13.921,46.572,46.572,0,0,0-1.392,7.332,39.219,39.219,0,0,0-.064,7.429c.052.619.1,1.238.193,1.85.041.306.075.615.122.919l.159.91.079.455.1.448.2.9.244.881.122.44.146.43a18.234,18.234,0,0,0,1.428,3.3,14.664,14.664,0,0,0,2.057,2.872,14.951,14.951,0,0,0,5.9,3.814,31.252,31.252,0,0,0,7.191,1.562c.621.075,1.248.135,1.876.193l.945.082c.313.024.643.059.925.063s.579.037.883.023l.9-.021c.61-.046,1.218-.079,1.834-.16a64.667,64.667,0,0,0,7.394-1.358c4.921-1.162,9.8-2.625,14.637-4.2s9.654-3.275,14.4-5.081l-.741,1.453a9.276,9.276,0,0,0-2.4-4.173,15.647,15.647,0,0,0-4.189-2.889c-.787-.4-1.6-.764-2.45-1.147-.422-.192-.851-.389-1.293-.614a8.107,8.107,0,0,1-1.384-.851,3.554,3.554,0,0,1-.374-.342l-.187-.208c-.063-.081-.124-.176-.182-.267a2.516,2.516,0,0,1-.278-.638l-.088-.337-.351-1.35c-.225-.9-.442-1.8-.646-2.707-.413-1.807-.808-3.616-1.155-5.433s-.64-3.641-.9-5.469a55.824,55.824,0,0,1-.624-11.067.414.414,0,0,1,.438-.388A.416.416,0,0,1-1266.875,540.1Z",
    transform: "translate(1314.767 -525.503)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7423",
    "data-name": "Grupo 7423",
    transform: "translate(-2200.567 -355.398)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2692",
    "data-name": "Trazado 2692",
    d: "M-1528.36,1843.13l-5.235.814a6.515,6.515,0,0,1-6.2-2.5h0a39.115,39.115,0,0,1-7.724-19.55h0a6.516,6.516,0,0,1,2.812-6.062l4.379-2.984",
    transform: "translate(1547.55 -1812.845)",
    fill: "#0af"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7425",
    "data-name": "Grupo 7425",
    transform: "translate(-2200.568 -354.753)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7424",
    "data-name": "Grupo 7424",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2693",
    "data-name": "Trazado 2693",
    d: "M-1539.406,1825.2l-4.336,2.955a7.215,7.215,0,0,0-2.479,2.921,7.2,7.2,0,0,0-.629,3.782q.159,1.525.427,3.032a39,39,0,0,1-1.1-6,6.492,6.492,0,0,1,.571-3.42,6.5,6.5,0,0,1,2.241-2.642l4.38-2.983Z",
    transform: "translate(1547.563 -1822.84)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7427",
    "data-name": "Grupo 7427",
    transform: "translate(-2197.233 -355.399)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7426",
    "data-name": "Grupo 7426",
    transform: "translate(0)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2694",
    "data-name": "Trazado 2694",
    d: "M-1495.906,1832.78h0a39.131,39.131,0,0,0,3.779,6.075,6.513,6.513,0,0,0,6.2,2.5l4.882-.76-10.965-27.758-.935.637,8.13,20.577-5.237.816A6.511,6.511,0,0,1-1495.906,1832.78Zm10.088-1.252-7.132-18.05.3-.2,7.189,18.2Z",
    transform: "translate(1495.906 -1812.84)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7428",
    "data-name": "Grupo 7428",
    transform: "translate(-2210.99 -370.491)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2695",
    "data-name": "Trazado 2695",
    d: "M-1678.474,1586.091c-2.722-5.332-12.048-12.388-30.393-.747a.314.314,0,0,0,.112.574c3.053.544,17.414,2.991,20.043,10.459",
    transform: "translate(1709.012 -1579.042)",
    fill: "#ec1c24"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7430",
    "data-name": "Grupo 7430",
    transform: "translate(-2210.99 -370.814)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7429",
    "data-name": "Grupo 7429",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2696",
    "data-name": "Trazado 2696",
    d: "M-1705.778,1581.49c-1.316-.282-2.371-.465-2.976-.573a.314.314,0,0,1-.113-.573c18.345-11.641,27.671-4.585,30.393.748l-1.109,1.113C-1683.1,1577.662-1691.373,1573.517-1705.778,1581.49Z",
    transform: "translate(1709.013 -1574.042)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7431",
    "data-name": "Grupo 7431",
    transform: "translate(-2212.213 -371.726)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2697",
    "data-name": "Trazado 2697",
    d: "M-1706.43,1579.708a1.223,1.223,0,0,1-1.153-.817c-.879-2.5-4.511-7.068-18.96-9.636l-.145-.026a1.526,1.526,0,0,1-1.236-1.215,1.527,1.527,0,0,1,.683-1.594c8.918-5.659,16.694-7.64,23.11-5.886a14.207,14.207,0,0,1,9.027,7.11,1.222,1.222,0,0,1-.533,1.644,1.223,1.223,0,0,1-1.645-.533,11.748,11.748,0,0,0-7.493-5.863c-5.181-1.416-11.769.1-19.153,4.376,13.163,2.723,17.426,7.334,18.651,10.812a1.222,1.222,0,0,1-.747,1.559A1.222,1.222,0,0,1-1706.43,1579.708Z",
    transform: "translate(1727.953 -1559.916)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7432",
    "data-name": "Grupo 7432",
    transform: "translate(-2188.627 -329.163)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2698",
    "data-name": "Trazado 2698",
    d: "M-1340.662,2219.777c1.658,5.753-.206,17.588-21.554,21.628a.314.314,0,0,1-.31-.5c1.856-2.484,10.538-14.414,7.353-21.663",
    transform: "translate(1362.588 -2219.246)",
    fill: "#d25658"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7433",
    "data-name": "Grupo 7433",
    transform: "translate(-2188.626 -329.163)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2699",
    "data-name": "Trazado 2699",
    d: "M-1362.2,2241.41a.315.315,0,0,1-.31-.5,56.179,56.179,0,0,0,5.711-9.354c1.91-4.092,3.173-8.7,1.673-12.23-.01-.026-.023-.052-.033-.078l.088,0,14.423.527a12.885,12.885,0,0,1,.209,5.976C-1341.572,2231.563-1346.845,2238.5-1362.2,2241.41Z",
    transform: "translate(1362.574 -2219.25)",
    fill: "#ec1c24"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7434",
    "data-name": "Grupo 7434",
    transform: "translate(-2182.852 -329.16)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2700",
    "data-name": "Trazado 2700",
    d: "M-1273.131,2231.6c1.91-4.092,3.173-8.7,1.673-12.23.018-.024.036-.051.055-.075l14.423.528a12.887,12.887,0,0,1,.209,5.976C-1260.213,2228.717-1265.429,2231.01-1273.131,2231.6Z",
    transform: "translate(1273.131 -2219.293)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7435",
    "data-name": "Grupo 7435",
    transform: "translate(-2189.85 -330.386)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2701",
    "data-name": "Trazado 2701",
    d: "M-1380,2224.917a1.525,1.525,0,0,1-1.3-.723,1.525,1.525,0,0,1,.072-1.733c2.392-3.2,9.983-14.134,7.212-20.44a1.222,1.222,0,0,1,.627-1.611,1.223,1.223,0,0,1,1.611.627c2.819,6.416-2.52,15.772-6.116,20.972,8.2-1.905,13.993-5.3,16.818-9.9a12.319,12.319,0,0,0,1.515-9.714,1.222,1.222,0,0,1,.836-1.513,1.222,1.222,0,0,1,1.513.836,14.6,14.6,0,0,1-1.782,11.672c-3.5,5.688-10.471,9.555-20.719,11.495A1.575,1.575,0,0,1-1380,2224.917Zm-.163-2.429h0Z",
    transform: "translate(1381.537 -2200.308)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7436",
    "data-name": "Grupo 7436",
    transform: "translate(-2193.697 -393.074)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2702",
    "data-name": "Trazado 2702",
    d: "M-1327.885,1239.673s-4.8,30.516-44.322,49.367c-33.673,16.057-56.954,8.146-56.954,8.146a46.9,46.9,0,0,1-10.114-18.224,46.9,46.9,0,0,1-1.849-12.063s5.17-9.68,19.208-19.47c.483-.336.978-.675,1.482-1.011a100.927,100.927,0,0,1,20.408-10.392q2.9-1.1,6.041-2.1c.083-.027.165-.052.247-.076a97.625,97.625,0,0,1,23.162-4.452c.223-.016.443-.027.663-.04C-1343.035,1227.854-1327.885,1239.673-1327.885,1239.673Z",
    transform: "translate(1441.123 -1229.225)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7437",
    "data-name": "Grupo 7437",
    transform: "translate(-2117.97 -393.07)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2703",
    "data-name": "Trazado 2703",
    d: "M-250.7,1273.229a113.058,113.058,0,0,0-17.359-43.941c24.273-.162,37.865,10.442,37.865,10.442S-232.873,1256.758-250.7,1273.229Z",
    transform: "translate(268.062 -1229.286)",
    fill: "#ec1c24"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7439",
    "data-name": "Grupo 7439",
    transform: "translate(-2117.97 -393.392)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7438",
    "data-name": "Grupo 7438",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2704",
    "data-name": "Trazado 2704",
    d: "M-230.7,1236.947c.377-1.417.5-2.216.5-2.216s-13.592-10.6-37.866-10.442q.854,1.284,1.671,2.59C-245.816,1227.16-233.289,1235.132-230.7,1236.947Z",
    transform: "translate(268.062 -1224.286)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7440",
    "data-name": "Grupo 7440",
    transform: "translate(-2120.241 -394.292)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2705",
    "data-name": "Trazado 2705",
    d: "M-284.434,1257.95l-.373-2.231a111.114,111.114,0,0,0-17.171-43.466l-1.252-1.884,2.262-.015c19.24-.133,31.947,6.446,36.519,9.279a4.52,4.52,0,0,1,2,5.053c-1.4,5.192-6.189,18.677-20.319,31.73Zm-14.262-45.135a113.407,113.407,0,0,1,15.9,40.25c12.4-12.117,16.69-24.234,17.982-29.017a2.092,2.092,0,0,0-.923-2.338C-269.948,1219.1-281.365,1213.187-298.7,1212.815Z",
    transform: "translate(303.231 -1210.352)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7441",
    "data-name": "Grupo 7441",
    transform: "translate(-2194.572 -394.294)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2706",
    "data-name": "Trazado 2706",
    d: "M-1425.854,1282.669c-9.981,0-15.779-1.932-16.023-2.015l-.3-.1-.214-.238a47.947,47.947,0,0,1-8.925-14.438,47.906,47.906,0,0,1-3.351-16.636l-.007-.32.151-.282c.122-.229,3.078-5.68,10.484-12.572,6.79-6.319,18.784-15.09,37.365-20.99a96.765,96.765,0,0,1,28.594-4.753l.66,0,.365.55a113.543,113.543,0,0,1,17.528,44.3l.243.659-.6.557a96.774,96.774,0,0,1-24.122,16.072c-17.6,8.392-32.348,10.185-41.623,10.212Zm-14.943-4.239a55.075,55.075,0,0,0,15.29,1.794c9-.042,23.32-1.806,40.447-9.974a94.7,94.7,0,0,0,23.028-15.214,111.072,111.072,0,0,0-16.7-42.264,94.684,94.684,0,0,0-27.209,4.631c-32.56,10.339-44.812,29.627-46.28,32.119a45.466,45.466,0,0,0,3.173,15.454A45.505,45.505,0,0,0-1440.8,1278.431Z",
    transform: "translate(1454.676 -1210.317)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7442",
    "data-name": "Grupo 7442",
    transform: "translate(-2201.789 -356.62)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2707",
    "data-name": "Trazado 2707",
    d: "M-1552.316,1827.537a7.726,7.726,0,0,1-6.163-3.066,40.336,40.336,0,0,1-7.964-20.161,7.728,7.728,0,0,1,3.339-7.2l4.378-2.984a1.223,1.223,0,0,1,1.7.322,1.222,1.222,0,0,1-.322,1.7l-4.379,2.984a5.286,5.286,0,0,0-2.284,4.925,37.893,37.893,0,0,0,7.482,18.94,5.287,5.287,0,0,0,5.033,2.034l5.236-.814a1.225,1.225,0,0,1,1.4,1.02,1.222,1.222,0,0,1-1.02,1.4l-5.236.815A7.809,7.809,0,0,1-1552.316,1827.537Z",
    transform: "translate(1566.486 -1793.915)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7443",
    "data-name": "Grupo 7443",
    transform: "translate(-2153.443 -384.893)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_264",
    "data-name": "Elipse 264",
    cx: 16.813,
    cy: 16.813,
    r: 16.813,
    transform: "translate(0 23.777) rotate(-45)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7444",
    "data-name": "Grupo 7444",
    transform: "translate(-2144.414 -378.313)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_265",
    "data-name": "Elipse 265",
    cx: 15.119,
    cy: 15.119,
    r: 15.119,
    transform: "translate(0 0)",
    fill: "#ec1c24"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7446",
    "data-name": "Grupo 7446",
    transform: "translate(-2144.417 -377.994)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7445",
    "data-name": "Grupo 7445",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2708",
    "data-name": "Trazado 2708",
    d: "M-647.754,1475.2q-.155-.492-.346-.976a15.119,15.119,0,0,0-19.615-8.506,15.121,15.121,0,0,0-9.312,16.823,15.119,15.119,0,0,1,8.846-18.659,15.122,15.122,0,0,1,19.619,8.508A15.278,15.278,0,0,1-647.754,1475.2Z",
    transform: "translate(677.747 -1462.818)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7447",
    "data-name": "Grupo 7447",
    transform: "translate(-2144.416 -365.462)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2709",
    "data-name": "Trazado 2709",
    d: "M-657.056,1673.279a15.118,15.118,0,0,1-19.615-8.5,15.052,15.052,0,0,1-.942-7.421,15.25,15.25,0,0,0,.89,3.291,15.119,15.119,0,0,0,19.617,8.508,15.11,15.11,0,0,0,9.447-12.2A15.123,15.123,0,0,1-657.056,1673.279Z",
    transform: "translate(677.731 -1656.95)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7448",
    "data-name": "Grupo 7448",
    transform: "translate(-2145.645 -379.544)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2710",
    "data-name": "Trazado 2710",
    d: "M-680.418,1471.513a16.3,16.3,0,0,1-6.5-1.358,16.234,16.234,0,0,1-8.7-8.988,16.234,16.234,0,0,1,.206-12.505,16.234,16.234,0,0,1,8.988-8.7,16.235,16.235,0,0,1,12.505.206,16.235,16.235,0,0,1,8.7,8.988,16.234,16.234,0,0,1-.206,12.505,16.234,16.234,0,0,1-8.988,8.7h0A16.33,16.33,0,0,1-680.418,1471.513Zm.007-30.254a13.886,13.886,0,0,0-5.109.98,13.805,13.805,0,0,0-7.644,7.4,13.806,13.806,0,0,0-.175,10.635,13.806,13.806,0,0,0,7.4,7.644,13.808,13.808,0,0,0,10.635.175h0a13.806,13.806,0,0,0,7.644-7.4,13.805,13.805,0,0,0,.175-10.635,13.8,13.8,0,0,0-7.4-7.644A13.863,13.863,0,0,0-680.411,1441.259Z",
    transform: "translate(696.764 -1438.814)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7449",
    "data-name": "Grupo 7449",
    transform: "translate(-2142.796 -377.03)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_266",
    "data-name": "Elipse 266",
    cx: 9.618,
    cy: 9.618,
    r: 9.618,
    transform: "translate(0 13.602) rotate(-45)",
    fill: "#6bd6f0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7451",
    "data-name": "Grupo 7451",
    transform: "translate(-2138.809 -366.657)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7450",
    "data-name": "Grupo 7450",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2711",
    "data-name": "Trazado 2711",
    d: "M-577.722,1650.619a9.618,9.618,0,0,1-12.479-5.413,9.511,9.511,0,0,1-.67-3.259c.035.1.073.2.112.3a9.618,9.618,0,0,0,12.479,5.413,9.618,9.618,0,0,0,6.083-9.22A9.619,9.619,0,0,1-577.722,1650.619Z",
    transform: "translate(590.871 -1638.442)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7452",
    "data-name": "Grupo 7452",
    transform: "translate(-2138.709 -372.739)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2712",
    "data-name": "Trazado 2712",
    d: "M-570.085,1554.035c-.055-.155-.109-.311-.171-.467a9.618,9.618,0,0,0-12.479-5.413,9.614,9.614,0,0,0-6.084,8.759,9.62,9.62,0,0,1,5.585-12.012,9.617,9.617,0,0,1,12.478,5.41A9.579,9.579,0,0,1-570.085,1554.035Z",
    transform: "translate(589.323 -1544.227)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7453",
    "data-name": "Grupo 7453",
    transform: "translate(-2140.035 -374.268)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2713",
    "data-name": "Trazado 2713",
    d: "M-599.018,1542.222a10.818,10.818,0,0,1-4.31-.9,10.77,10.77,0,0,1-5.77-5.963,10.853,10.853,0,0,1,6.1-14.065,10.853,10.853,0,0,1,14.065,6.1,10.853,10.853,0,0,1-6.1,14.065A10.834,10.834,0,0,1-599.018,1542.222Zm-.007-19.243a8.349,8.349,0,0,0-3.075.588,8.4,8.4,0,0,0-4.724,10.894,8.341,8.341,0,0,0,4.469,4.618,8.338,8.338,0,0,0,6.425.106h0a8.406,8.406,0,0,0,4.724-10.894A8.411,8.411,0,0,0-599.025,1522.979Z",
    transform: "translate(609.856 -1520.534)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7454",
    "data-name": "Grupo 7454",
    transform: "translate(-2109.836 -388.124)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2714",
    "data-name": "Trazado 2714",
    d: "M-130.027,1309.971c-.073-2.3-4.843-4.1-7.543-4.075-2.8.022-4.477.5-4.49,1.857-.017,1.89,2.161,2.556,4.749,2.654C-135.481,1310.476-129.937,1312.8-130.027,1309.971Z",
    transform: "translate(142.059 -1305.896)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7455",
    "data-name": "Grupo 7455",
    transform: "translate(-2096.754 -385.18)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2715",
    "data-name": "Trazado 2715",
    d: "M66.548,1355.528c-.15-1.99-2.556-3.844-3.866-3.995-1.356-.156-2.149.156-2.087,1.325a2.672,2.672,0,0,0,2.438,2.592C63.925,1355.624,66.733,1357.984,66.548,1355.528Z",
    transform: "translate(-60.591 -1351.496)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7457",
    "data-name": "Grupo 7457",
    transform: "translate(-2193.341 -384.583)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7456",
    "data-name": "Grupo 7456",
    transform: "translate(0)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2716",
    "data-name": "Trazado 2716",
    d: "M-1424.3,1417.959s23.28,7.911,56.951-8.144c34.195-16.307,42.395-41.343,43.985-47.8q.243.162.426.29c-.5-.345-1.319-.89-2.463-1.555-4.643,10.551-15.694,27.527-41.149,39.667-15.9,7.581-29.481,9.819-39.389,10.069a27.987,27.987,0,0,1-27.617-19.942l-.059-.2c-.14-.482-.27-.967-.394-1.454-.065-.2-.132-.4-.193-.6l-.059-.2c-.021-.072-.039-.144-.059-.216l.045-.066h0c-.924,1.347-1.344,2.133-1.344,2.133a46.812,46.812,0,0,0,1.474,10.691A46.844,46.844,0,0,0-1424.3,1417.959Z",
    transform: "translate(1435.62 -1360.749)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7458",
    "data-name": "Grupo 7458",
    transform: "translate(-2199.6 -347.713)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2717",
    "data-name": "Trazado 2717",
    d: "M-1516.64,1943.933c-6.932,2.736-15.924-.054-15.924-.054s.017-.031.052-.086c.523-.887,5.026-8.263,11.534-10.837,6.246-2.469,13.049.065,14.26.559.124.051.189.08.189.08S-1509.754,1941.217-1516.64,1943.933Z",
    transform: "translate(1532.564 -1931.892)",
    fill: "#ec1c24"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7460",
    "data-name": "Grupo 7460",
    transform: "translate(-2199.278 -347.391)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7459",
    "data-name": "Grupo 7459",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2718",
    "data-name": "Trazado 2718",
    d: "M-1501.544,1938.594s-.2.464-.595,1.2c-2.318-.8-8.055-2.341-13.388-.233-5.233,2.069-9.171,7.245-10.785,9.651-.8-.19-1.269-.334-1.269-.334l.052-.088c.523-.886,5.027-8.261,11.535-10.836,6.245-2.47,13.046.065,14.258.558Z",
    transform: "translate(1527.581 -1936.893)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7461",
    "data-name": "Grupo 7461",
    transform: "translate(-2199.6 -346.091)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2719",
    "data-name": "Trazado 2719",
    d: "M-1516.64,1967.45c-6.932,2.736-15.924-.054-15.924-.054s.017-.032.052-.086l25.794-10.278c.124.051.189.08.189.08S-1509.754,1964.734-1516.64,1967.45Z",
    transform: "translate(1532.564 -1957.031)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7462",
    "data-name": "Grupo 7462",
    transform: "translate(-2201.414 -348.94)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2720",
    "data-name": "Trazado 2720",
    d: "M-1550.07,1928.591a34.014,34.014,0,0,1-9.15-1.316l-1.452-.451.752-1.321c.2-.349,4.954-8.59,12.2-11.455,7.278-2.877,15.065.512,15.393.658l1.1.488-.468,1.106c-.14.33-3.507,8.127-10.787,11A20.8,20.8,0,0,1-1550.07,1928.591Zm-6.849-3.25c2.791.625,8.757,1.572,13.538-.315s7.7-6.4,8.86-8.53c-2.3-.761-7.533-2.059-12.3-.175C-1551.612,1918.214-1555.312,1922.978-1556.92,1925.34Zm-1.938.767h0Z",
    transform: "translate(1560.672 -1912.892)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7463",
    "data-name": "Grupo 7463",
    transform: "translate(-2174.489 -386.274)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2721",
    "data-name": "Trazado 2721",
    d: "M-1118.323,1360.222c.963,1.381,7.612,12.6,2.261,17.057-4.684,3.905-13.329,3.263-17.885-2.875a19.053,19.053,0,0,1-3.45-12.323c.2-4.183.95-8.174-1.137-11.306a23.219,23.219,0,0,0-5.048-4.816c.483-.336.978-.675,1.482-1.011a100.912,100.912,0,0,1,20.408-10.392,16.325,16.325,0,0,1,4.415,3.031c5.072,5.033,5.213,15.135,1.769,19.229C-1116.863,1358.429-1118.323,1360.222-1118.323,1360.222Z",
    transform: "translate(1143.581 -1334.555)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7464",
    "data-name": "Grupo 7464",
    transform: "translate(-2186.583 -436.606)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2722",
    "data-name": "Trazado 2722",
    d: "M-1290.517,627.812c.963,1.381,7.612,12.6,2.261,17.057-4.684,3.905-13.329,3.263-17.885-2.875a19.052,19.052,0,0,1-3.45-12.323c.2-4.183.95-8.174-1.137-11.306-2.374-3.569-11.639-4.9-16.247-10.184-2.717-3.111-4.171-8.76-3.924-15.682a48.826,48.826,0,0,1,.712-6.628,64.246,64.246,0,0,1,15.309-31s3.5,14.007,7.172,26.453c2.557,8.675,5.2,16.592,6.784,18.465a1.047,1.047,0,0,0,.574.416,21.857,21.857,0,0,1,6.075,1.76,16.63,16.63,0,0,1,4.8,3.214c5.072,5.033,5.213,15.135,1.769,19.229C-1289.057,626.018-1290.517,627.812-1290.517,627.812Z",
    transform: "translate(1330.925 -554.868)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7465",
    "data-name": "Grupo 7465",
    transform: "translate(-2186.583 -410.918)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2723",
    "data-name": "Trazado 2723",
    d: "M-1286.548,1014.56a5.39,5.39,0,0,1-1.708,2.558c-4.684,3.905-13.329,3.263-17.885-2.875a19.048,19.048,0,0,1-3.45-12.323c.2-4.183.947-8.174-1.137-11.3-2.374-3.569-11.639-4.9-16.25-10.184-2.714-3.111-4.168-8.767-3.921-15.684,0-.031,0-.064,0-.095.009-.232.021-.464.034-.7.012-.214.025-.431.04-.651.006-.1.012-.2.021-.3.04-.516.086-1.039.144-1.568.027-.25.058-.5.089-.761.021-.177.046-.358.07-.538.018-.15.04-.3.061-.449.034-.235.07-.471.107-.709.043-.269.089-.541.134-.813l.009-.046a6.305,6.305,0,0,1,.464-.477,19.823,19.823,0,0,0,2.894.929,71.578,71.578,0,0,0,17.836,1.852l-.141-4.629a2.338,2.338,0,0,1,1.427-2.224,2.26,2.26,0,0,1,.663-.171l5.546-.593,8.018,19.412-7.443-.183-5.6-.138a2.341,2.341,0,0,1-2.191-2.264l-.07-2.325c-4.9,1.1-13,1.384-18.251-.345.391,4.834,1.739,8.739,3.828,11.135,4.608,5.283,11.517,2.447,16.192,7.9,2.921,3.41,1.393,9.408,1.192,13.591-.171,3.581-1.555,8.834,1.451,12.892C-1300.39,1017.845-1291.785,1017.368-1286.548,1014.56Z",
    transform: "translate(1330.925 -952.806)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7466",
    "data-name": "Grupo 7466",
    transform: "translate(-2185.844 -438.159)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2724",
    "data-name": "Trazado 2724",
    d: "M-1260.468,532.4a32.52,32.52,0,0,1-11.541,9.848,32.118,32.118,0,0,1-6.988,2.582,32.412,32.412,0,0,1-7.884.911,32.2,32.2,0,0,1-13.5-3.048,8.139,8.139,0,0,0-10.845,4.028,58.759,58.759,0,0,0-4.888,17.109,19.807,19.807,0,0,1-2.894-.929,6.336,6.336,0,0,0-.464.477,64.242,64.242,0,0,1,15.309-31l.092.938c1.17-1.6,1.916-2.49,1.916-2.49l29.212,1.491s.113,1.54.348,4.095A97.2,97.2,0,0,0-1260.468,532.4Z",
    transform: "translate(1319.475 -530.822)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7467",
    "data-name": "Grupo 7467",
    transform: "translate(-2187.8 -436.953)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2725",
    "data-name": "Trazado 2725",
    d: "M-1317.391,594.857a15.614,15.614,0,0,1,4.719.7,16.7,16.7,0,0,1,4.41,2.045,15.48,15.48,0,0,1,1.961,1.547,13.1,13.1,0,0,1,1.664,1.932,15.5,15.5,0,0,1,2.124,4.512,19.933,19.933,0,0,1,.761,4.846,18.576,18.576,0,0,1-.428,4.9,11.64,11.64,0,0,1-2.084,4.667l-2.937,3.558.055-1.471c.246.36.436.677.635,1.01s.382.661.562,1q.544,1,1.024,2.034a29.574,29.574,0,0,1,1.628,4.291,15.931,15.931,0,0,1,.686,4.7,8.8,8.8,0,0,1-.395,2.507,6.818,6.818,0,0,1-1.282,2.334l-.22.258c-.076.083-.161.156-.241.234a4.85,4.85,0,0,1-.494.433c-.335.242-.66.5-1.008.723-.358.2-.712.414-1.075.6l-1.125.484a13.59,13.59,0,0,1-4.747.8,14.967,14.967,0,0,1-4.712-.8,14.044,14.044,0,0,1-4.2-2.3,8.326,8.326,0,0,1-.913-.782c-.283-.284-.586-.55-.849-.852l-.767-.926c-.252-.311-.459-.642-.69-.962a18.985,18.985,0,0,1-2.053-4.231,20.949,20.949,0,0,1-.97-4.565,22.259,22.259,0,0,1-.117-2.319c0-.387.011-.773.025-1.159l.065-1.119c.095-1.483.224-2.926.227-4.318a10.7,10.7,0,0,0-.584-3.885,3.148,3.148,0,0,0-.181-.428c-.071-.136-.125-.283-.208-.412l-.237-.395a3.757,3.757,0,0,0-.243-.32,6.592,6.592,0,0,0-1.412-1.174,30.336,30.336,0,0,0-3.753-1.923,46.32,46.32,0,0,1-7.993-4.2,14.9,14.9,0,0,1-3.436-3.318,16.019,16.019,0,0,1-2.121-4.244,27.123,27.123,0,0,1-1.076-4.489,38.69,38.69,0,0,1-.373-4.541,49.033,49.033,0,0,1,.71-8.995,62.25,62.25,0,0,1,5.639-16.989,65.459,65.459,0,0,1,4.446-7.784,26.026,26.026,0,0,1,6.158-6.5.419.419,0,0,1,.583.1.419.419,0,0,1,.029.435l0,0c-1.39,2.659-3.042,5-4.606,7.419a67.392,67.392,0,0,0-4.419,7.411,59.81,59.81,0,0,0-5.418,16.313,46.612,46.612,0,0,0-.676,8.531,36.258,36.258,0,0,0,.347,4.228,24.742,24.742,0,0,0,.971,4.06,13.609,13.609,0,0,0,1.791,3.606,12.507,12.507,0,0,0,2.878,2.762,44.357,44.357,0,0,0,7.578,3.957,32.373,32.373,0,0,1,4.071,2.1,8.953,8.953,0,0,1,1.948,1.645,6.212,6.212,0,0,1,.42.557l.33.549c.112.182.192.38.288.569a5.043,5.043,0,0,1,.248.584,10.266,10.266,0,0,1,.6,2.4,16.935,16.935,0,0,1,.145,2.363c0,1.544-.141,3.027-.233,4.472l-.062,1.078c-.011.347-.025.694-.022,1.041a19.8,19.8,0,0,0,.1,2.075,18.525,18.525,0,0,0,.854,4.029,14.046,14.046,0,0,0,4.469,6.615,11.6,11.6,0,0,0,3.483,1.91,12.524,12.524,0,0,0,3.924.667,11.157,11.157,0,0,0,3.888-.649l.9-.386c.286-.151.561-.318.844-.474.271-.171.517-.376.779-.56a2.745,2.745,0,0,0,.333-.29c.051-.049.107-.094.155-.147l.135-.163a5.149,5.149,0,0,0,1.1-3.325,13.553,13.553,0,0,0-.593-3.972,27.226,27.226,0,0,0-1.494-3.931c-.3-.641-.617-1.275-.955-1.9-.168-.312-.343-.618-.52-.921s-.367-.608-.534-.854l-.525-.769.58-.7,2.921-3.538a9.118,9.118,0,0,0,1.6-3.677,16.922,16.922,0,0,0-.443-8.453,14.528,14.528,0,0,0-1.78-3.78,11.372,11.372,0,0,0-1.289-1.585,12.993,12.993,0,0,0-1.585-1.375,23.912,23.912,0,0,0-3.71-2.236,39.513,39.513,0,0,0-4.143-1.711h0a.414.414,0,0,1-.25-.529A.415.415,0,0,1-1317.391,594.857Z",
    transform: "translate(1349.771 -549.5)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7468",
    "data-name": "Grupo 7468",
    transform: "translate(-2166.254 -389.143)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2726",
    "data-name": "Trazado 2726",
    d: "M-1014.9,1310.339a.917.917,0,0,1-.907-.794c-1.426-10.548,4.821-15.535,7.573-17.189,4.562-2.743,10.06-3,13.369-.623a.917.917,0,0,1,.21,1.279.916.916,0,0,1-1.279.21c-2.689-1.931-7.465-1.634-11.356.7-2.441,1.468-7.98,5.9-6.7,15.372a.917.917,0,0,1-.786,1.031A.907.907,0,0,1-1014.9,1310.339Z",
    transform: "translate(1016.021 -1290.111)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7469",
    "data-name": "Grupo 7469",
    transform: "translate(-2155.868 -365.923)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2727",
    "data-name": "Trazado 2727",
    d: "M-843.758,1651.91c-.129.123-.216.2-.324.287s-.207.166-.312.246c-.208.161-.425.305-.644.447a11.283,11.283,0,0,1-1.373.745,10.206,10.206,0,0,1-3.035.851,7.277,7.277,0,0,1-3.159-.278,5.4,5.4,0,0,1-2.529-1.725,12.674,12.674,0,0,0,2.774.266,9.2,9.2,0,0,0,1.275-.112,7.554,7.554,0,0,0,1.232-.271,12.231,12.231,0,0,0,2.344-.983c.381-.195.747-.42,1.115-.641l.539-.347.5-.334.075-.05a1.222,1.222,0,0,1,1.7.331A1.222,1.222,0,0,1-843.758,1651.91Z",
    transform: "translate(855.133 -1649.803)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7470",
    "data-name": "Grupo 7470",
    transform: "translate(-2123.144 -471.542)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2728",
    "data-name": "Trazado 2728",
    d: "M-344.257,35.995h0a.659.659,0,0,1-.7-.616l-1.211-18.95a.659.659,0,0,1,.616-.7h0a6.916,6.916,0,0,1,7.343,6.461l.413,6.462A6.916,6.916,0,0,1-344.257,35.995Z",
    transform: "translate(346.301 -15.583)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2729",
    "data-name": "Trazado 2729",
    d: "M-346.2,34.233a.792.792,0,0,1-.789-.74l-1.211-18.95a.791.791,0,0,1,.738-.839,7.056,7.056,0,0,1,7.482,6.583l.413,6.462a7,7,0,0,1-1.742,5.1,7,7,0,0,1-4.841,2.378h0Zm.042-.132h0ZM-347,13.951q-.221,0-.442.014a.525.525,0,0,0-.363.178.526.526,0,0,0-.13.383l1.211,18.95a.527.527,0,0,0,.561.493A6.74,6.74,0,0,0-341.5,31.68a6.74,6.74,0,0,0,1.677-4.915l-.413-6.462a6.741,6.741,0,0,0-2.289-4.661A6.736,6.736,0,0,0-347,13.951Z",
    transform: "translate(348.2 -13.689)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7471",
    "data-name": "Grupo 7471",
    transform: "translate(-2122.124 -461.504)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2730",
    "data-name": "Trazado 2730",
    d: "M-325.114,169.183l.194,3.031a6.919,6.919,0,0,1-6.462,7.344.661.661,0,0,1-.7-.617l-.324-5.038a.66.66,0,0,0,.624.352l.449-.03A6.911,6.911,0,0,0-325.114,169.183Z",
    transform: "translate(332.405 -169.183)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7472",
    "data-name": "Grupo 7472",
    transform: "translate(-2124.235 -472.634)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2731",
    "data-name": "Trazado 2731",
    d: "M-362.011,19.5a1.884,1.884,0,0,1-1.877-1.761L-365.1-1.21a1.883,1.883,0,0,1,1.758-2A8.08,8.08,0,0,1-357.446-1.2,8.084,8.084,0,0,1-354.7,4.395l.413,6.462a8.085,8.085,0,0,1-2.012,5.9A8.084,8.084,0,0,1-361.89,19.5h0C-361.931,19.5-361.971,19.5-362.011,19.5Zm.043-1.224h0Zm-.654-19.055L-361.486,17a5.7,5.7,0,0,0,4.759-5.982l-.413-6.462A5.657,5.657,0,0,0-359.061.639,5.652,5.652,0,0,0-362.622-.777Z",
    transform: "translate(365.103 3.225)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7473",
    "data-name": "Grupo 7473",
    transform: "translate(-2191.553 -467.53)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2732",
    "data-name": "Trazado 2732",
    d: "M-1399.407,77.857h0a.659.659,0,0,1,.7.616l1.211,18.951a.659.659,0,0,1-.616.7h0a6.916,6.916,0,0,1-7.343-6.461l-.413-6.462A6.916,6.916,0,0,1-1399.407,77.857Z",
    transform: "translate(1406.013 -77.725)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2733",
    "data-name": "Trazado 2733",
    d: "M-1400.463,96.378a7,7,0,0,1-4.645-1.757,7,7,0,0,1-2.378-4.841l-.413-6.462a7,7,0,0,1,1.742-5.1,7,7,0,0,1,4.841-2.378h0a.792.792,0,0,1,.839.738l1.211,18.951a.786.786,0,0,1-.2.572.785.785,0,0,1-.543.267Q-1400.234,96.378-1400.463,96.378ZM-1401.3,76.1a6.74,6.74,0,0,0-4.661,2.289,6.74,6.74,0,0,0-1.677,4.915l.413,6.462a6.739,6.739,0,0,0,2.289,4.661,6.734,6.734,0,0,0,4.915,1.677.524.524,0,0,0,.363-.178.523.523,0,0,0,.131-.383l-1.211-18.951a.528.528,0,0,0-.561-.493Z",
    transform: "translate(1407.914 -75.835)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7474",
    "data-name": "Grupo 7474",
    transform: "translate(-2191.168 -456.315)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2734",
    "data-name": "Trazado 2734",
    d: "M-1394.149,252.8l.335,5.257a.661.661,0,0,1-.617.7,6.9,6.9,0,0,1-5.207-1.89,6.892,6.892,0,0,1-2.135-4.57l-.174-2.723a6.918,6.918,0,0,0,6.547,3.652l.692-.044A.667.667,0,0,0-1394.149,252.8Z",
    transform: "translate(1401.947 -249.571)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7475",
    "data-name": "Grupo 7475",
    transform: "translate(-2192.644 -468.622)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2735",
    "data-name": "Trazado 2735",
    d: "M-1416.271,81.649a8.149,8.149,0,0,1-8.116-7.619l-.413-6.462a8.085,8.085,0,0,1,2.012-5.9,8.084,8.084,0,0,1,5.591-2.746h0a1.882,1.882,0,0,1,2,1.757l1.211,18.951a1.867,1.867,0,0,1-.465,1.363,1.868,1.868,0,0,1-1.292.635Q-1416.01,81.649-1416.271,81.649Zm-1.331-20.22a5.7,5.7,0,0,0-4.759,5.982l.413,6.462a5.657,5.657,0,0,0,1.921,3.912,5.653,5.653,0,0,0,3.561,1.416Z",
    transform: "translate(1424.817 -58.922)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7476",
    "data-name": "Grupo 7476",
    transform: "translate(-2198.782 -505.027)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_267",
    "data-name": "Elipse 267",
    cx: 32.359,
    cy: 32.359,
    r: 32.359,
    transform: "translate(0 45.763) rotate(-45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2736",
    "data-name": "Trazado 2736",
    d: "M-1281.8-234.445h-.236a32.527,32.527,0,0,1-32.257-32.721,32.529,32.529,0,0,1,32.485-32.258h.236a32.276,32.276,0,0,1,22.905,9.68,32.277,32.277,0,0,1,9.352,23.041A32.529,32.529,0,0,1-1281.8-234.445Zm-.01-64.718a32.011,32.011,0,0,0-22.619,9.277,32.017,32.017,0,0,0-9.6,22.721,32.017,32.017,0,0,0,9.276,22.855,32.017,32.017,0,0,0,22.721,9.6,32.038,32.038,0,0,0,22.855-9.276,32.018,32.018,0,0,0,9.6-22.721,32.018,32.018,0,0,0-9.276-22.856,32.017,32.017,0,0,0-22.721-9.6Z",
    transform: "translate(1327.567 312.697)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7477",
    "data-name": "Grupo 7477",
    transform: "translate(-2185.38 -463.514)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2737",
    "data-name": "Trazado 2737",
    d: "M-1247.844,138.037a32.17,32.17,0,0,1,.279,4.482,32.364,32.364,0,0,1-32.591,32.128,32.364,32.364,0,0,1-32.128-32.591c0-.514.019-1.028.047-1.535a32.364,32.364,0,0,0,31.849,28.109A32.364,32.364,0,0,0-1247.844,138.037Z",
    transform: "translate(1312.285 -138.037)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7478",
    "data-name": "Grupo 7478",
    transform: "translate(-2186.601 -492.846)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2738",
    "data-name": "Trazado 2738",
    d: "M-1297.611-249.167h-.247a33.362,33.362,0,0,1-23.675-10.005,33.361,33.361,0,0,1-9.666-23.815,33.361,33.361,0,0,1,10.005-23.675,33.356,33.356,0,0,1,23.815-9.666,33.362,33.362,0,0,1,23.675,10.005,33.361,33.361,0,0,1,9.666,23.815,33.362,33.362,0,0,1-10.005,23.675A33.359,33.359,0,0,1-1297.611-249.167Zm-.013-64.718a30.928,30.928,0,0,0-21.853,8.963,30.932,30.932,0,0,0-9.277,21.951,30.933,30.933,0,0,0,8.962,22.082,30.932,30.932,0,0,0,21.951,9.277,30.96,30.96,0,0,0,22.082-8.962,30.933,30.933,0,0,0,9.277-21.951,30.934,30.934,0,0,0-8.962-22.082,30.932,30.932,0,0,0-21.951-9.277Z",
    transform: "translate(1331.199 316.329)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7479",
    "data-name": "Grupo 7479",
    transform: "translate(-2185.085 -481.652)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2739",
    "data-name": "Trazado 2739",
    d: "M-1243.41-119.475a29.023,29.023,0,0,1-5.435,17.119c-2.606,3.667-13.389,10.135-26.766,10.362-12.4.21-23.742-6.313-26.406-9.939a29.026,29.026,0,0,1-5.707-17.03c-.133-16.756,14.208-23.817,31.968-23.959S-1243.543-136.231-1243.41-119.475Z",
    transform: "translate(1307.724 142.924)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7480",
    "data-name": "Grupo 7480",
    transform: "translate(-2185.814 -482.381)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2740",
    "data-name": "Trazado 2740",
    d: "M-1286.777-101.829c-12.563,0-23.652-6.511-26.394-10.242a29.726,29.726,0,0,1-5.848-17.456c-.065-8.18,3.164-14.512,9.6-18.821,5.622-3.766,13.608-5.8,23.094-5.872s17.5,1.828,23.185,5.5c6.5,4.206,9.831,10.487,9.9,18.667h0a29.723,29.723,0,0,1-5.57,17.547c-2.56,3.6-13.21,10.429-27.348,10.669C-1286.369-101.831-1286.574-101.829-1286.777-101.829Zm.94-50.935-.478,0c-9.449.075-31.41,2.489-31.245,23.223a28.277,28.277,0,0,0,5.565,16.6c2.513,3.419,13.318,9.646,25.231,9.647.192,0,.383,0,.575,0,13.451-.228,23.848-6.769,26.184-10.055a28.274,28.274,0,0,0,5.3-16.691h0C-1254.868-150.431-1276.146-152.764-1285.838-152.764Z",
    transform: "translate(1319.02 154.223)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7481",
    "data-name": "Grupo 7481",
    transform: "translate(-2136.305 -466.746)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_268",
    "data-name": "Elipse 268",
    cx: 5.727,
    cy: 4.15,
    rx: 5.727,
    ry: 4.15,
    transform: "translate(0 11.285) rotate(-80.185)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7482",
    "data-name": "Grupo 7482",
    transform: "translate(-2139.182 -452.203)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_269",
    "data-name": "Elipse 269",
    cx: 2.628,
    cy: 2.256,
    rx: 2.628,
    ry: 2.256,
    transform: "translate(0 5.006) rotate(-72.243)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7483",
    "data-name": "Grupo 7483",
    transform: "translate(-2166.258 -473.785)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2741",
    "data-name": "Trazado 2741",
    d: "M-976.961-21.063c3.961,3.72,6.324,8.851,6.378,15.581a29.04,29.04,0,0,1-5.434,17.12c-2.607,3.667-13.391,10.135-26.768,10.363a39.912,39.912,0,0,1-13.285-2.159c16.437-.631,29.572-8.568,32.8-13.117A36.829,36.829,0,0,0-976.368-15,32.764,32.764,0,0,0-976.961-21.063Z",
    transform: "translate(1016.069 21.063)",
    fill: "#111a28"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7484",
    "data-name": "Grupo 7484",
    transform: "translate(-2183.788 -486.24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2742",
    "data-name": "Trazado 2742",
    d: "M-1285.653-199l-1.919-1.514.9.721-.96-.641c5.681-8.506,16.781-13.447,30.455-13.556,13.588-.1,24.74,4.492,30.649,12.62a1.224,1.224,0,0,1-.043,1.537,1.22,1.22,0,0,1-1.721.134,1.272,1.272,0,0,1-.2-.214c-5.435-7.494-15.887-11.74-28.667-11.632-12.851.1-23.218,4.647-28.442,12.469C-1285.615-199.051-1285.633-199.025-1285.653-199Zm-.964-.751h0Z",
    transform: "translate(1287.63 213.992)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7485",
    "data-name": "Grupo 7485",
    transform: "translate(-2179.368 -477.197)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2743",
    "data-name": "Trazado 2743",
    d: "M-1217.581-44.5s-5.321-16.489,3.535-23.147,21.673-6.733,21.38-5.909c0,0-14.162,3.548-19.625,14.81C-1216.5-50.066-1217.581-44.5-1217.581-44.5Z",
    transform: "translate(1219.166 73.92)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7486",
    "data-name": "Grupo 7486",
    transform: "translate(-2157.878 -414.234)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2744",
    "data-name": "Trazado 2744",
    d: "M-860.987,903.833l.875,6.757.682,5.256a2.743,2.743,0,0,1-2.175,3.043c-.909.186-2.038.4-3.338.628a102.18,102.18,0,0,1-18.271,1.585,2.746,2.746,0,0,1-2.7-2.677l-.353-13.951a2.745,2.745,0,0,1,2.814-2.815c4.752.122,14.22.279,19.5-.207A2.74,2.74,0,0,1-860.987,903.833Z",
    transform: "translate(886.264 -901.439)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7487",
    "data-name": "Grupo 7487",
    transform: "translate(-2162.91 -414.012)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2745",
    "data-name": "Trazado 2745",
    d: "M-956.574,904.875l-5.546.592a2.338,2.338,0,0,0-2.089,2.4l.422,13.841a2.338,2.338,0,0,0,2.191,2.263l5.125.321",
    transform: "translate(964.211 -904.875)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7488",
    "data-name": "Grupo 7488",
    transform: "translate(-2162.91 -414.012)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2746",
    "data-name": "Trazado 2746",
    d: "M-956.574,904.875l-5.546.592a2.338,2.338,0,0,0-2.089,2.4l.422,13.841a2.338,2.338,0,0,0,2.191,2.263l5.125.321",
    transform: "translate(964.211 -904.875)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7489",
    "data-name": "Grupo 7489",
    transform: "translate(-2158.957 -415.313)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2747",
    "data-name": "Trazado 2747",
    d: "M-897.719,906.545q-.572,0-1.144-.009a3.812,3.812,0,0,1-3.757-3.729l-.353-13.952a3.791,3.791,0,0,1,1.12-2.8,3.8,3.8,0,0,1,2.8-1.119c5.02.128,14.211.272,19.369-.2a3.81,3.81,0,0,1,4.135,3.318l1.557,12.012a3.839,3.839,0,0,1-3.029,4.24A108.947,108.947,0,0,1-897.719,906.545Zm-1.432-19.455a1.649,1.649,0,0,0-1.176.488,1.652,1.652,0,0,0-.488,1.222l.353,13.952a1.66,1.66,0,0,0,1.633,1.626,105.33,105.33,0,0,0,21.379-2.192,1.673,1.673,0,0,0,1.32-1.848l-1.557-12.012a1.656,1.656,0,0,0-1.8-1.447c-5.268.485-14.554.341-19.621.212h-.044Z",
    transform: "translate(902.975 -884.714)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7490",
    "data-name": "Grupo 7490",
    transform: "translate(-2163.989 -415.091)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2748",
    "data-name": "Trazado 2748",
    d: "M-972.1,909.724l-.069,0-5.124-.321a3.4,3.4,0,0,1-3.2-3.307l-.422-13.841a3.432,3.432,0,0,1,3.053-3.5l5.546-.592a1.076,1.076,0,0,1,1.187.958,1.079,1.079,0,0,1-.958,1.187l-5.546.592a1.265,1.265,0,0,0-1.125,1.291l.422,13.841a1.253,1.253,0,0,0,1.18,1.218l5.125.321a1.079,1.079,0,0,1,1.009,1.144A1.079,1.079,0,0,1-972.1,909.724Z",
    transform: "translate(980.924 -888.153)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7491",
    "data-name": "Grupo 7491",
    transform: "translate(-2149.602 -414.981)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2749",
    "data-name": "Trazado 2749",
    d: "M-751.932,910.845a1.079,1.079,0,0,1-1.076-1.016l-.413-7.069L-757,900.345a1.079,1.079,0,0,1-.473-.82l-.586-8.514a1.079,1.079,0,0,1,1-1.15,1.08,1.08,0,0,1,1.151,1l.549,7.988,3.585,2.418a1.078,1.078,0,0,1,.474.831l.444,7.6a1.079,1.079,0,0,1-1.014,1.14Z",
    transform: "translate(758.061 -889.858)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7492",
    "data-name": "Grupo 7492",
    transform: "translate(-2139.517 -409.208)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2750",
    "data-name": "Trazado 2750",
    d: "M-595.721,983.11c.045.428-.2,3.947-.2,3.947l-2.439.254c-1.68.175-3.222-1.423-3.445-3.568s.958-4.026,2.637-4.2l2.439-.254S-595.794,982.413-595.721,983.11Z",
    transform: "translate(601.83 -979.289)",
    fill: "#22a7f0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7493",
    "data-name": "Grupo 7493",
    transform: "translate(-2139.515 -409.207)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2751",
    "data-name": "Trazado 2751",
    d: "M-595.705,983.119c.045.428-.2,3.947-.2,3.947l-.081.008c.063-1.016.127-2.221.1-2.461-.071-.7-1-3.821-1-3.821l-2.439.254a3.072,3.072,0,0,0-2.485,2.375c-.079-2.005,1.066-3.7,2.66-3.869l2.439-.254S-595.776,982.422-595.705,983.119Z",
    transform: "translate(601.812 -979.298)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7494",
    "data-name": "Grupo 7494",
    transform: "translate(-2140.433 -410.053)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2752",
    "data-name": "Trazado 2752",
    d: "M-611.885,975.994c-2.043,0-3.849-1.9-4.109-4.4-.275-2.645,1.275-4.98,3.454-5.207l1.7-.177a1.8,1.8,0,0,1,1.921,1.293,22.091,22.091,0,0,1,.828,3.269h0a28.1,28.1,0,0,1-.145,3.353,1.8,1.8,0,0,1-1.614,1.678l-1.694.176A3.279,3.279,0,0,1-611.885,975.994Zm1.214-7.961-1.68.175c-1.154.12-1.988,1.583-1.82,3.194s1.286,2.867,2.438,2.751l1.67-.174c.126-1.953.159-2.849.149-3.026A29.677,29.677,0,0,0-610.671,968.034Z",
    transform: "translate(616.026 -966.198)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7495",
    "data-name": "Grupo 7495",
    transform: "translate(-2137.455 -409.524)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_270",
    "data-name": "Elipse 270",
    cx: 3.057,
    cy: 3.905,
    rx: 3.057,
    ry: 3.905,
    transform: "translate(0 0.633) rotate(-5.938)",
    fill: "#22a7f0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7496",
    "data-name": "Grupo 7496",
    transform: "translate(-2137.078 -409.221)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2753",
    "data-name": "Trazado 2753",
    d: "M-557.944,982.674a4.856,4.856,0,0,1,.02.764c-.464-1.75-1.829-2.961-3.3-2.808s-2.568,1.626-2.657,3.437a4.978,4.978,0,0,1-.14-.761c-.223-2.145.959-4.025,2.638-4.2S-558.167,980.529-557.944,982.674Z",
    transform: "translate(564.053 -979.093)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7497",
    "data-name": "Grupo 7497",
    transform: "translate(-2137.994 -410.138)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2754",
    "data-name": "Trazado 2754",
    d: "M-574.116,974.506a3.7,3.7,0,0,1-2.67-1.207,5.4,5.4,0,0,1-1.428-3.2,5.4,5.4,0,0,1,.74-3.421,3.645,3.645,0,0,1,2.714-1.786,3.643,3.643,0,0,1,3.023,1.189,5.4,5.4,0,0,1,1.429,3.2h0a5.4,5.4,0,0,1-.74,3.421,3.646,3.646,0,0,1-2.714,1.786A3.4,3.4,0,0,1-574.116,974.506Zm-.3-7.795a1.484,1.484,0,0,0-.154.008,1.857,1.857,0,0,0-1.351.937,3.563,3.563,0,0,0-.47,2.257,3.563,3.563,0,0,0,.924,2.112,1.853,1.853,0,0,0,1.514.639,1.857,1.857,0,0,0,1.35-.937,3.563,3.563,0,0,0,.47-2.257h0a3.564,3.564,0,0,0-.924-2.112A1.915,1.915,0,0,0-574.417,966.711Z",
    transform: "translate(578.247 -964.877)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7498",
    "data-name": "Grupo 7498",
    transform: "translate(-2187.673 -409.136)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2755",
    "data-name": "Trazado 2755",
    d: "M-1345.52,980.4s7.3,3.3,24.651,2.706c0,0,3.179,3.047,0,5.564s-21.073,3.966-25.853-1.192C-1349.748,984.212-1345.52,980.4-1345.52,980.4Z",
    transform: "translate(1347.813 -980.4)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7499",
    "data-name": "Grupo 7499",
    transform: "translate(-2187.674 -406.618)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2756",
    "data-name": "Trazado 2756",
    d: "M-1320.878,1025.159c-3.178,2.515-21.072,3.963-25.854-1.195a3.884,3.884,0,0,1-.626-4.559,4.407,4.407,0,0,0,.626.852c4.782,5.158,22.676,3.71,25.854,1.195a4.4,4.4,0,0,0,.807-.816A3.183,3.183,0,0,1-1320.878,1025.159Z",
    transform: "translate(1347.822 -1019.405)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7500",
    "data-name": "Grupo 7500",
    transform: "translate(-2188.752 -410.41)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2757",
    "data-name": "Trazado 2757",
    d: "M-1349.1,973.569c-4.052,0-10.986-.519-14.046-3.821a4.8,4.8,0,0,1-1.374-3.568c.123-2.74,2.542-4.951,2.645-5.044l.524-.473.641.29c.11.049,7.4,3.189,24.17,2.612l.455-.016.329.315a5.682,5.682,0,0,1,1.741,3.967,4.326,4.326,0,0,1-1.818,3.222c-2.132,1.688-8.228,2.487-12.99,2.515Zm-11.775-10.365a5.5,5.5,0,0,0-1.489,3.08,2.683,2.683,0,0,0,.8,2c4.378,4.725,21.708,3.2,24.391,1.08a2.244,2.244,0,0,0,1-1.631,3.281,3.281,0,0,0-.8-1.992C-1351.227,966.173-1358.651,964.006-1360.878,963.2Z",
    transform: "translate(1364.528 -960.663)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7501",
    "data-name": "Grupo 7501",
    transform: "translate(-2146.31 -392.902)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2758",
    "data-name": "Trazado 2758",
    d: "M-683.663,1241.278c-2.613,3.156-10.991,6.2-15.5,3.376-3.768-2.359-3.887-5.739-6.557-7.682a11.766,11.766,0,0,0-1.345-.632,97.624,97.624,0,0,1,23.162-4.452C-680.9,1235.582-681.5,1238.662-683.663,1241.278Z",
    transform: "translate(707.066 -1231.888)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7502",
    "data-name": "Grupo 7502",
    transform: "translate(-2170.532 -423.453)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2759",
    "data-name": "Trazado 2759",
    d: "M-1071.068,758.626c9.45,11.79,25.041,19.018,34.355,27.422,5.1,4.606,4.3,6.822,1.755,9.9-2.611,3.158-8.743,6.2-13.253,3.378-3.767-2.361-4-4.6-6.672-6.548-1.053-.767-18-5.263-27.4-19.922",
    transform: "translate(1082.284 -758.626)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7503",
    "data-name": "Grupo 7503",
    transform: "translate(-2170.532 -409.466)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2760",
    "data-name": "Trazado 2760",
    d: "M-1034.958,998.629c-2.609,3.156-8.742,6.2-13.252,3.376-3.767-2.359-4-4.6-6.673-6.548-1.051-.767-17.995-5.262-27.4-19.923l.192-.244c10.49,11.028,21.424,11.688,28.687,17.277,2.617,2.014,2.844,2.682,6.612,5.041,4.51,2.826,10.643-.22,13.252-3.376q.252-.3.477-.6C-1032.632,995.417-1033.515,996.884-1034.958,998.629Z",
    transform: "translate(1082.283 -975.29)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7504",
    "data-name": "Grupo 7504",
    transform: "translate(-2170.885 -423.795)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2761",
    "data-name": "Trazado 2761",
    d: "M-1075.864,753.409a67.607,67.607,0,0,1,5.432,4.568c1.738,1.562,3.524,3.084,5.327,4.6,1.835,1.482,3.735,2.887,5.682,4.244s3.911,2.7,5.882,4.042,3.958,2.682,5.911,4.094c.492.345.978.7,1.461,1.066s.97.718,1.45,1.087c.949.757,1.911,1.493,2.825,2.307a27.858,27.858,0,0,1,2.705,2.573c.21.247.422.488.628.742.2.271.4.53.585.814l.268.445.132.223c.041.078.077.163.116.244l.225.494c.066.172.118.358.175.537a4.867,4.867,0,0,1,.117,2.332,6.5,6.5,0,0,1-.81,2.044,14.065,14.065,0,0,1-1.134,1.6c-.187.243-.41.494-.637.743s-.466.471-.7.7a14.922,14.922,0,0,1-3.185,2.23,13.979,13.979,0,0,1-3.678,1.329,10.24,10.24,0,0,1-4.035.05l-.507-.117a2.918,2.918,0,0,1-.5-.146c-.324-.127-.661-.227-.972-.385s-.623-.327-.916-.5c-.267-.18-.54-.348-.8-.54a14.455,14.455,0,0,1-1.511-1.24,15.7,15.7,0,0,1-1.319-1.423,28.752,28.752,0,0,0-2.2-2.635c-.091-.1-.192-.176-.289-.263a3.774,3.774,0,0,0-.3-.249l-.154-.12-.077-.06-.038-.03c-.018-.014,0,0,0,0a.045.045,0,0,0,.022.014l-.064-.029c-.052-.023-.09-.043-.16-.07-.5-.206-1.078-.421-1.634-.637-1.123-.434-2.249-.891-3.361-1.378a58.046,58.046,0,0,1-12.573-7.392c-.968-.747-1.9-1.547-2.809-2.365-.9-.835-1.82-1.645-2.67-2.536a16.017,16.017,0,0,1-1.22-1.384c-.2-.238-.388-.478-.56-.734s-.355-.5-.524-.762a12.849,12.849,0,0,1-.886-1.631,9.877,9.877,0,0,1-.594-1.8.434.434,0,0,1,.333-.517.433.433,0,0,1,.333.063l.021.014a12.323,12.323,0,0,1,1.413,1.168c.451.394.844.824,1.254,1.238.2.208.4.423.591.638s.4.422.589.637.391.426.578.646.391.425.583.642a33.433,33.433,0,0,0,2.409,2.505c.862.778,1.744,1.535,2.665,2.246a55.614,55.614,0,0,0,12.047,7.079c1.074.471,2.16.911,3.262,1.337.557.216,1.1.416,1.7.664.069.027.165.072.25.11.047.022.077.034.139.066s.145.081.216.125c.03.019.082.051.093.061l.05.039.1.077.2.155a10,10,0,0,1,.76.663,29.693,29.693,0,0,1,2.4,2.844,12.049,12.049,0,0,0,2.365,2.229c.219.162.456.306.683.46l.657.355c.219.115.462.177.69.273a1.664,1.664,0,0,0,.358.1l.365.085a7.809,7.809,0,0,0,3.07-.049,12.346,12.346,0,0,0,5.69-2.959c.188-.187.4-.362.562-.563s.35-.384.527-.615a11.733,11.733,0,0,0,.938-1.315,4.087,4.087,0,0,0,.514-1.26,2.412,2.412,0,0,0-.068-1.2,7,7,0,0,0-1.6-2.539,25.636,25.636,0,0,0-2.481-2.352c-.868-.774-1.8-1.489-2.719-2.22-.465-.359-.943-.706-1.414-1.06s-.945-.7-1.43-1.044c-1.915-1.384-3.891-2.713-5.858-4.057s-3.956-2.679-5.917-4.066c-1.97-1.37-3.894-2.821-5.835-4.257a49.643,49.643,0,0,1-5.514-4.744,20.522,20.522,0,0,1-4.32-5.9.419.419,0,0,1,.2-.557.419.419,0,0,1,.419.036Z",
    transform: "translate(1087.751 -753.321)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7505",
    "data-name": "Grupo 7505",
    transform: "translate(-2159.662 -411.998)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2762",
    "data-name": "Trazado 2762",
    d: "M-912.817,952.081a1.08,1.08,0,0,1-.256-.031,1.079,1.079,0,0,1-.793-1.3c.147-.6,3.693-14.67,13.491-14.67h.16a1.079,1.079,0,0,1,1.062,1.1,1.07,1.07,0,0,1-1.1,1.062h-.12c-8.13,0-11.369,12.892-11.4,13.023A1.08,1.08,0,0,1-912.817,952.081Z",
    transform: "translate(913.897 -936.076)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7506",
    "data-name": "Grupo 7506",
    transform: "translate(-2125.02 -438.956)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2763",
    "data-name": "Trazado 2763",
    d: "M-370.862,539.125a1.074,1.074,0,0,1-.527-.138c-5.44-3.056-5.838-17.762-5.865-19.429a1.079,1.079,0,0,1,1.061-1.1h.018a1.079,1.079,0,0,1,1.079,1.061c.07,4.186,1.063,15.5,4.764,17.583a1.079,1.079,0,0,1,.412,1.469A1.079,1.079,0,0,1-370.862,539.125Z",
    transform: "translate(377.254 -518.461)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7507",
    "data-name": "Grupo 7507",
    transform: "translate(-2111.666 -446.869)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2764",
    "data-name": "Trazado 2764",
    d: "M-168.433,396.864c.011.067.016.193.023.3l.02.331c.019.222.027.448.049.673.03.452.086.9.151,1.359s.158.91.247,1.385c.071.488.194.963.253,1.543a3.755,3.755,0,0,1-1.305-1.027,5.016,5.016,0,0,1-.475-.677,7.762,7.762,0,0,1-.364-.741,7.2,7.2,0,0,1-.474-1.582,6.934,6.934,0,0,1-.091-.825c-.005-.14-.011-.279,0-.421a3.882,3.882,0,0,1,.037-.456.962.962,0,0,1,1.08-.828.963.963,0,0,1,.825.8Z",
    transform: "translate(170.406 -395.885)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6201",
    "data-name": "Grupo 6201",
    transform: "matrix(0.999, -0.035, 0.035, 0.999, 592.161, 56.565)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8129",
    "data-name": "Grupo 8129"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3129",
    "data-name": "Trazado 3129",
    d: "M62.5,213.27a3.718,3.718,0,0,1-1.868,1.03,5.458,5.458,0,0,1-2.649-.113l-1.847-.481L54.991,218.1l-2.979-.776,3.182-12.228,4.826,1.255a5.68,5.68,0,0,1,2.342,1.149,3.585,3.585,0,0,1,1.153,1.788,4.2,4.2,0,0,1-.025,2.169A4.077,4.077,0,0,1,62.5,213.27Zm-2.751-1.581a1.8,1.8,0,0,0,.589-2.264,1.833,1.833,0,0,0-1.168-.732l-1.619-.422-.8,3.066,1.62.422A1.835,1.835,0,0,0,59.746,211.689Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3130",
    "data-name": "Trazado 3130",
    d: "M68.771,208.2,66.5,220.636l-3.028-.553,2.268-12.431Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3131",
    "data-name": "Trazado 3131",
    d: "M72.525,219.094l4,.474-.279,2.36-7.061-.837,1.488-12.549,3.056.363Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3132",
    "data-name": "Trazado 3132",
    d: "M81.2,221.523a6.189,6.189,0,0,1-2.319-2.351,6.8,6.8,0,0,1,.11-6.668,6.2,6.2,0,0,1,2.4-2.265,6.858,6.858,0,0,1,6.533.108,6.087,6.087,0,0,1,2.3,2.342,6.9,6.9,0,0,1-.119,6.668,6.146,6.146,0,0,1-2.378,2.274,6.843,6.843,0,0,1-6.525-.108Zm5.737-2.893a4.37,4.37,0,0,0,.088-5.336,3.108,3.108,0,0,0-2.4-1.039,3.149,3.149,0,0,0-2.455.949,4.4,4.4,0,0,0-.088,5.355A3.135,3.135,0,0,0,84.5,219.6,3.1,3.1,0,0,0,86.938,218.63Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3133",
    "data-name": "Trazado 3133",
    d: "M101.324,208.725l.233,2.454-3.333.316.958,10.124-3.065.29-.958-10.124-3.333.316-.232-2.455Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3134",
    "data-name": "Trazado 3134",
    d: "M107.42,219.764a6.192,6.192,0,0,1-2.781-1.783,6.809,6.809,0,0,1-1.363-6.528,6.21,6.21,0,0,1,1.837-2.737,6.859,6.859,0,0,1,6.4-1.336,6.091,6.091,0,0,1,2.761,1.777,6.9,6.9,0,0,1,1.354,6.531,6.155,6.155,0,0,1-1.817,2.742,6.848,6.848,0,0,1-6.388,1.334Zm4.957-4.088a4.37,4.37,0,0,0-1.091-5.225,3.467,3.467,0,0,0-4.759.986,4.4,4.4,0,0,0,1.1,5.241,3.134,3.134,0,0,0,2.592.479A3.1,3.1,0,0,0,112.377,215.676Z",
    fill: "#fff"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_551",
    "data-name": "Rect\\xE1ngulo 551",
    width: 248,
    height: 248,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPiloto);
export default __webpack_public_path__ + "static/media/Piloto.72c1079b0af9f024cf39772e78cb0fbc.svg";
export { ForwardRef as ReactComponent };